import androidx.compose.runtime.*
import org.jetbrains.compose.web.dom.*
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.attributes.*
import io.ktor.client.*
import io.ktor.client.request.*
import io.ktor.client.call.*
import io.ktor.http.*
import com.example.rhnaf.shared.model.*
import kotlinx.coroutines.launch
import kotlin.coroutines.suspendCoroutine
import kotlin.coroutines.resume
import kotlin.coroutines.resumeWithException
import kotlinx.browser.window
import kotlinx.browser.document
import org.w3c.dom.HTMLInputElement
import org.w3c.files.FileReader
import org.w3c.files.get
import kotlinx.serialization.json.Json
import kotlinx.serialization.json.JsonObject
import kotlinx.serialization.json.JsonPrimitive

// Modulos estilo SAP integrados a RHNAF: CO, MM (Compras), PP, QM, EWM, GTS, EHS (Auditorias), SAP Security/GRC
// Sigue el mismo patron que los modulos existentes en Main.kt (Warehouse/Attendance): HttpClient + LaunchedEffect + formulario inline.

@Composable
fun ControllingModule(client: HttpClient, scope: kotlinx.coroutines.CoroutineScope, t: Translations) {
    var items by remember { mutableStateOf(emptyList<CostCenter>()) }
    var isLoading by remember { mutableStateOf(true) }
    var refreshKey by remember { mutableStateOf(0) }

    LaunchedEffect(refreshKey) {
        isLoading = true
        try {
            items = client.get("$BACKEND_URL/api/v1/sap/co/centros-costo").body()
        } catch (e: Exception) {
            println("Error cargando ControllingModule: ${e.message}")
        } finally {
            isLoading = false
        }
    }
    fun refresh() { refreshKey++ }

    var f_codigo by remember { mutableStateOf("") }
    var f_nombre by remember { mutableStateOf("") }
    var f_departamento by remember { mutableStateOf("") }
    var f_presupuestoMensual by remember { mutableStateOf("") }
    var f_gastoActual by remember { mutableStateOf("") }

    Div({ style { backgroundColor(Color.white); padding(32.px); borderRadius(12.px); property("box-shadow", CardShadow) } }) {
        Div({ style { display(DisplayStyle.Flex); justifyContent(JustifyContent.SpaceBetween); alignItems(AlignItems.Center); marginBottom(16.px) } }) {
            H3({ style { margin(0.px) } }) { Text("CO · Control de Costos (Controlling)") }
            Span({ style { color(Color.gray); fontSize(13.px) } }) { Text("${items.size} registros") }
        }

        Div({ style { display(DisplayStyle.Flex); gap(8.px); marginBottom(16.px); flexWrap(FlexWrap.Wrap); alignItems(AlignItems.Center) } }) {
            Input(InputType.Text) { placeholder("Codigo *"); value(f_codigo); onInput { f_codigo = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(100.px) } }
            Input(InputType.Text) { placeholder("Nombre del centro de costo"); value(f_nombre); onInput { f_nombre = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(220.px) } }
            Input(InputType.Text) { placeholder("Departamento"); value(f_departamento); onInput { f_departamento = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(180.px) } }
            Input(InputType.Text) { placeholder("Presupuesto mensual"); value(f_presupuestoMensual); onInput { f_presupuestoMensual = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(160.px) } }
            Input(InputType.Text) { placeholder("Gasto actual"); value(f_gastoActual); onInput { f_gastoActual = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(140.px) } }
            Button({
                style { padding(8.px, 16.px); backgroundColor(SidebarActiveColor); color(Color.white); property("border", "none"); borderRadius(6.px); cursor("pointer") }
                onClick {
                    if (f_codigo.isNotBlank()) {
                        scope.launch {
                            client.post("$BACKEND_URL/api/v1/sap/co/centros-costo") {
                                contentType(ContentType.Application.Json)
                                setBody(CostCenter(codigo = f_codigo, nombre = f_nombre, departamento = f_departamento, presupuestoMensual = f_presupuestoMensual, gastoActual = f_gastoActual))
                            }
                            f_codigo = ""
                            f_nombre = ""
                            f_departamento = ""
                            f_presupuestoMensual = ""
                            f_gastoActual = ""
                            refresh()
                        }
                    } else {
                        window.alert("Completa el campo obligatorio para agregar el registro.")
                    }
                }
            }) { Text("+ Agregar") }
        }

        if (isLoading) {
            P { Text("Cargando...") }
        } else {
            Table({ style { width(100.percent) } }) {
                Thead { Tr { Th { Text("Codigo") }; Th { Text("Nombre") }; Th { Text("Departamento") }; Th { Text("Presupuesto") }; Th { Text("Gasto Actual") }; Th { Text("") } } }
                Tbody {
                    items.forEach { row ->
                        Tr {
                            Td { Text(row.codigo) }; Td { Text(row.nombre) }; Td { Text(row.departamento) }; Td { Text(row.presupuestoMensual) }; Td { Text(row.gastoActual) }
                            Td {
                                Button({
                                    style { backgroundColor(Color("#ef4444")); color(Color.white); property("border", "none"); borderRadius(4.px); padding(4.px, 10.px); cursor("pointer") }
                                    onClick { scope.launch { client.delete("$BACKEND_URL/api/v1/sap/co/centros-costo/${row.id}"); refresh() } }
                                }) { Text("Eliminar") }
                            }
                        }
                    }
                }
            }
        }
    }
}

@Composable
fun PurchasingModule(client: HttpClient, scope: kotlinx.coroutines.CoroutineScope, t: Translations) {
    var items by remember { mutableStateOf(emptyList<PurchaseOrder>()) }
    var isLoading by remember { mutableStateOf(true) }
    var refreshKey by remember { mutableStateOf(0) }

    LaunchedEffect(refreshKey) {
        isLoading = true
        try {
            items = client.get("$BACKEND_URL/api/v1/sap/mm/ordenes-compra").body()
        } catch (e: Exception) {
            println("Error cargando PurchasingModule: ${e.message}")
        } finally {
            isLoading = false
        }
    }
    fun refresh() { refreshKey++ }

    var f_numero by remember { mutableStateOf("") }
    var f_proveedor by remember { mutableStateOf("") }
    var f_fecha by remember { mutableStateOf("") }
    var f_descripcion by remember { mutableStateOf("") }
    var f_montoTotal by remember { mutableStateOf("") }
    var f_estado by remember { mutableStateOf("") }

    Div({ style { backgroundColor(Color.white); padding(32.px); borderRadius(12.px); property("box-shadow", CardShadow) } }) {
        Div({ style { display(DisplayStyle.Flex); justifyContent(JustifyContent.SpaceBetween); alignItems(AlignItems.Center); marginBottom(16.px) } }) {
            H3({ style { margin(0.px) } }) { Text("MM · Compras y Abastecimiento (Materials Management)") }
            Span({ style { color(Color.gray); fontSize(13.px) } }) { Text("${items.size} registros") }
        }

        Div({ style { display(DisplayStyle.Flex); gap(8.px); marginBottom(16.px); flexWrap(FlexWrap.Wrap); alignItems(AlignItems.Center) } }) {
            Input(InputType.Text) { placeholder("No. Orden *"); value(f_numero); onInput { f_numero = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(120.px) } }
            Input(InputType.Text) { placeholder("Proveedor"); value(f_proveedor); onInput { f_proveedor = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(200.px) } }
            Input(InputType.Text) { placeholder("Fecha"); value(f_fecha); onInput { f_fecha = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(130.px) } }
            Input(InputType.Text) { placeholder("Descripcion"); value(f_descripcion); onInput { f_descripcion = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(220.px) } }
            Input(InputType.Text) { placeholder("Monto total"); value(f_montoTotal); onInput { f_montoTotal = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(130.px) } }
            Input(InputType.Text) { placeholder("Estado"); value(f_estado); onInput { f_estado = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(120.px) } }
            Button({
                style { padding(8.px, 16.px); backgroundColor(SidebarActiveColor); color(Color.white); property("border", "none"); borderRadius(6.px); cursor("pointer") }
                onClick {
                    if (f_numero.isNotBlank()) {
                        scope.launch {
                            client.post("$BACKEND_URL/api/v1/sap/mm/ordenes-compra") {
                                contentType(ContentType.Application.Json)
                                setBody(PurchaseOrder(numero = f_numero, proveedor = f_proveedor, fecha = f_fecha, descripcion = f_descripcion, montoTotal = f_montoTotal, estado = f_estado))
                            }
                            f_numero = ""
                            f_proveedor = ""
                            f_fecha = ""
                            f_descripcion = ""
                            f_montoTotal = ""
                            f_estado = ""
                            refresh()
                        }
                    } else {
                        window.alert("Completa el campo obligatorio para agregar el registro.")
                    }
                }
            }) { Text("+ Agregar") }
        }

        if (isLoading) {
            P { Text("Cargando...") }
        } else {
            Table({ style { width(100.percent) } }) {
                Thead { Tr { Th { Text("No. Orden") }; Th { Text("Proveedor") }; Th { Text("Fecha") }; Th { Text("Descripcion") }; Th { Text("Monto Total") }; Th { Text("Estado") }; Th { Text("") } } }
                Tbody {
                    items.forEach { row ->
                        Tr {
                            Td { Text(row.numero) }; Td { Text(row.proveedor) }; Td { Text(row.fecha) }; Td { Text(row.descripcion) }; Td { Text(row.montoTotal) }; Td { Text(row.estado) }
                            Td {
                                Button({
                                    style { backgroundColor(Color("#ef4444")); color(Color.white); property("border", "none"); borderRadius(4.px); padding(4.px, 10.px); cursor("pointer") }
                                    onClick { scope.launch { client.delete("$BACKEND_URL/api/v1/sap/mm/ordenes-compra/${row.id}"); refresh() } }
                                }) { Text("Eliminar") }
                            }
                        }
                    }
                }
            }
        }
    }
}

@Composable
fun ProductionModule(client: HttpClient, scope: kotlinx.coroutines.CoroutineScope, t: Translations) {
    var items by remember { mutableStateOf(emptyList<ProductionOrder>()) }
    var isLoading by remember { mutableStateOf(true) }
    var refreshKey by remember { mutableStateOf(0) }

    LaunchedEffect(refreshKey) {
        isLoading = true
        try {
            items = client.get("$BACKEND_URL/api/v1/sap/pp/ordenes-produccion").body()
        } catch (e: Exception) {
            println("Error cargando ProductionModule: ${e.message}")
        } finally {
            isLoading = false
        }
    }
    fun refresh() { refreshKey++ }

    var f_numero by remember { mutableStateOf("") }
    var f_producto by remember { mutableStateOf("") }
    var f_cantidadPlan by remember { mutableStateOf("") }
    var f_cantidadProducida by remember { mutableStateOf("") }
    var f_centroTrabajo by remember { mutableStateOf("") }
    var f_fechaInicio by remember { mutableStateOf("") }
    var f_fechaFin by remember { mutableStateOf("") }
    var f_estado by remember { mutableStateOf("") }

    Div({ style { backgroundColor(Color.white); padding(32.px); borderRadius(12.px); property("box-shadow", CardShadow) } }) {
        Div({ style { display(DisplayStyle.Flex); justifyContent(JustifyContent.SpaceBetween); alignItems(AlignItems.Center); marginBottom(16.px) } }) {
            H3({ style { margin(0.px) } }) { Text("PP · Planificacion de Produccion (Production Planning)") }
            Span({ style { color(Color.gray); fontSize(13.px) } }) { Text("${items.size} registros") }
        }

        Div({ style { display(DisplayStyle.Flex); gap(8.px); marginBottom(16.px); flexWrap(FlexWrap.Wrap); alignItems(AlignItems.Center) } }) {
            Input(InputType.Text) { placeholder("No. Orden *"); value(f_numero); onInput { f_numero = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(120.px) } }
            Input(InputType.Text) { placeholder("Producto"); value(f_producto); onInput { f_producto = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(200.px) } }
            Input(InputType.Text) { placeholder("Cant. planeada"); value(f_cantidadPlan); onInput { f_cantidadPlan = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(130.px) } }
            Input(InputType.Text) { placeholder("Cant. producida"); value(f_cantidadProducida); onInput { f_cantidadProducida = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(130.px) } }
            Input(InputType.Text) { placeholder("Centro de trabajo"); value(f_centroTrabajo); onInput { f_centroTrabajo = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(160.px) } }
            Input(InputType.Text) { placeholder("Fecha inicio"); value(f_fechaInicio); onInput { f_fechaInicio = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(130.px) } }
            Input(InputType.Text) { placeholder("Fecha fin"); value(f_fechaFin); onInput { f_fechaFin = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(130.px) } }
            Input(InputType.Text) { placeholder("Estado"); value(f_estado); onInput { f_estado = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(120.px) } }
            Button({
                style { padding(8.px, 16.px); backgroundColor(SidebarActiveColor); color(Color.white); property("border", "none"); borderRadius(6.px); cursor("pointer") }
                onClick {
                    if (f_numero.isNotBlank()) {
                        scope.launch {
                            client.post("$BACKEND_URL/api/v1/sap/pp/ordenes-produccion") {
                                contentType(ContentType.Application.Json)
                                setBody(ProductionOrder(numero = f_numero, producto = f_producto, cantidadPlan = f_cantidadPlan, cantidadProducida = f_cantidadProducida, centroTrabajo = f_centroTrabajo, fechaInicio = f_fechaInicio, fechaFin = f_fechaFin, estado = f_estado))
                            }
                            f_numero = ""
                            f_producto = ""
                            f_cantidadPlan = ""
                            f_cantidadProducida = ""
                            f_centroTrabajo = ""
                            f_fechaInicio = ""
                            f_fechaFin = ""
                            f_estado = ""
                            refresh()
                        }
                    } else {
                        window.alert("Completa el campo obligatorio para agregar el registro.")
                    }
                }
            }) { Text("+ Agregar") }
        }

        if (isLoading) {
            P { Text("Cargando...") }
        } else {
            Table({ style { width(100.percent) } }) {
                Thead { Tr { Th { Text("No. Orden") }; Th { Text("Producto") }; Th { Text("Cant. Plan") }; Th { Text("Cant. Producida") }; Th { Text("Centro Trabajo") }; Th { Text("Inicio") }; Th { Text("Fin") }; Th { Text("Estado") }; Th { Text("") } } }
                Tbody {
                    items.forEach { row ->
                        Tr {
                            Td { Text(row.numero) }; Td { Text(row.producto) }; Td { Text(row.cantidadPlan) }; Td { Text(row.cantidadProducida) }; Td { Text(row.centroTrabajo) }; Td { Text(row.fechaInicio) }; Td { Text(row.fechaFin) }; Td { Text(row.estado) }
                            Td {
                                Button({
                                    style { backgroundColor(Color("#ef4444")); color(Color.white); property("border", "none"); borderRadius(4.px); padding(4.px, 10.px); cursor("pointer") }
                                    onClick { scope.launch { client.delete("$BACKEND_URL/api/v1/sap/pp/ordenes-produccion/${row.id}"); refresh() } }
                                }) { Text("Eliminar") }
                            }
                        }
                    }
                }
            }
        }
    }
}

@Composable
fun QualityModule(client: HttpClient, scope: kotlinx.coroutines.CoroutineScope, t: Translations) {
    var items by remember { mutableStateOf(emptyList<QualityInspection>()) }
    var isLoading by remember { mutableStateOf(true) }
    var refreshKey by remember { mutableStateOf(0) }

    LaunchedEffect(refreshKey) {
        isLoading = true
        try {
            items = client.get("$BACKEND_URL/api/v1/sap/qm/inspecciones").body()
        } catch (e: Exception) {
            println("Error cargando QualityModule: ${e.message}")
        } finally {
            isLoading = false
        }
    }
    fun refresh() { refreshKey++ }

    var f_fecha by remember { mutableStateOf("") }
    var f_loteProducto by remember { mutableStateOf("") }
    var f_inspector by remember { mutableStateOf("") }
    var f_resultado by remember { mutableStateOf("") }
    var f_observaciones by remember { mutableStateOf("") }

    Div({ style { backgroundColor(Color.white); padding(32.px); borderRadius(12.px); property("box-shadow", CardShadow) } }) {
        Div({ style { display(DisplayStyle.Flex); justifyContent(JustifyContent.SpaceBetween); alignItems(AlignItems.Center); marginBottom(16.px) } }) {
            H3({ style { margin(0.px) } }) { Text("QM · Gestion de Calidad (Quality Management)") }
            Span({ style { color(Color.gray); fontSize(13.px) } }) { Text("${items.size} registros") }
        }

        Div({ style { display(DisplayStyle.Flex); gap(8.px); marginBottom(16.px); flexWrap(FlexWrap.Wrap); alignItems(AlignItems.Center) } }) {
            Input(InputType.Text) { placeholder("Fecha *"); value(f_fecha); onInput { f_fecha = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(130.px) } }
            Input(InputType.Text) { placeholder("Lote / Producto"); value(f_loteProducto); onInput { f_loteProducto = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(180.px) } }
            Input(InputType.Text) { placeholder("Auditor"); value(f_inspector); onInput { f_inspector = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(160.px) } }
            Input(InputType.Text) { placeholder("Resultado (Aprobado/Rechazado)"); value(f_resultado); onInput { f_resultado = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(200.px) } }
            Input(InputType.Text) { placeholder("Observaciones"); value(f_observaciones); onInput { f_observaciones = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(220.px) } }
            Button({
                style { padding(8.px, 16.px); backgroundColor(SidebarActiveColor); color(Color.white); property("border", "none"); borderRadius(6.px); cursor("pointer") }
                onClick {
                    if (f_fecha.isNotBlank()) {
                        scope.launch {
                            client.post("$BACKEND_URL/api/v1/sap/qm/inspecciones") {
                                contentType(ContentType.Application.Json)
                                setBody(QualityInspection(fecha = f_fecha, loteProducto = f_loteProducto, inspector = f_inspector, resultado = f_resultado, observaciones = f_observaciones))
                            }
                            f_fecha = ""
                            f_loteProducto = ""
                            f_inspector = ""
                            f_resultado = ""
                            f_observaciones = ""
                            refresh()
                        }
                    } else {
                        window.alert("Completa el campo obligatorio para agregar el registro.")
                    }
                }
            }) { Text("+ Agregar") }
        }

        if (isLoading) {
            P { Text("Cargando...") }
        } else {
            Table({ style { width(100.percent) } }) {
                Thead { Tr { Th { Text("Fecha") }; Th { Text("Lote/Producto") }; Th { Text("Inspector") }; Th { Text("Resultado") }; Th { Text("Observaciones") }; Th { Text("") } } }
                Tbody {
                    items.forEach { row ->
                        Tr {
                            Td { Text(row.fecha) }; Td { Text(row.loteProducto) }; Td { Text(row.inspector) }; Td { Text(row.resultado) }; Td { Text(row.observaciones) }
                            Td {
                                Button({
                                    style { backgroundColor(Color("#ef4444")); color(Color.white); property("border", "none"); borderRadius(4.px); padding(4.px, 10.px); cursor("pointer") }
                                    onClick { scope.launch { client.delete("$BACKEND_URL/api/v1/sap/qm/inspecciones/${row.id}"); refresh() } }
                                }) { Text("Eliminar") }
                            }
                        }
                    }
                }
            }
        }
    }
}

@Composable
fun GtsTradeModule(client: HttpClient, scope: kotlinx.coroutines.CoroutineScope, t: Translations) {
    var items by remember { mutableStateOf(emptyList<CustomsDeclaration>()) }
    var isLoading by remember { mutableStateOf(true) }
    var refreshKey by remember { mutableStateOf(0) }

    LaunchedEffect(refreshKey) {
        isLoading = true
        try {
            items = client.get("$BACKEND_URL/api/v1/sap/gts/pedimentos").body()
        } catch (e: Exception) {
            println("Error cargando GtsTradeModule: ${e.message}")
        } finally {
            isLoading = false
        }
    }
    fun refresh() { refreshKey++ }

    var f_numeroPedimento by remember { mutableStateOf("") }
    var f_fecha by remember { mutableStateOf("") }
    var f_cliente by remember { mutableStateOf("") }
    var f_paisDestino by remember { mutableStateOf("") }
    var f_valorAduana by remember { mutableStateOf("") }
    var f_regimen by remember { mutableStateOf("") }
    var f_estado by remember { mutableStateOf("") }

    Div({ style { backgroundColor(Color.white); padding(32.px); borderRadius(12.px); property("box-shadow", CardShadow) } }) {
        Div({ style { display(DisplayStyle.Flex); justifyContent(JustifyContent.SpaceBetween); alignItems(AlignItems.Center); marginBottom(16.px) } }) {
            H3({ style { margin(0.px) } }) { Text("GTS · Comercio Exterior (Global Trade Services)") }
            Span({ style { color(Color.gray); fontSize(13.px) } }) { Text("${items.size} registros") }
        }

        Div({ style { display(DisplayStyle.Flex); gap(8.px); marginBottom(16.px); flexWrap(FlexWrap.Wrap); alignItems(AlignItems.Center) } }) {
            Input(InputType.Text) { placeholder("No. Pedimento *"); value(f_numeroPedimento); onInput { f_numeroPedimento = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(150.px) } }
            Input(InputType.Text) { placeholder("Fecha"); value(f_fecha); onInput { f_fecha = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(130.px) } }
            Input(InputType.Text) { placeholder("Cliente"); value(f_cliente); onInput { f_cliente = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(180.px) } }
            Input(InputType.Text) { placeholder("Pais destino"); value(f_paisDestino); onInput { f_paisDestino = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(140.px) } }
            Input(InputType.Text) { placeholder("Valor aduana"); value(f_valorAduana); onInput { f_valorAduana = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(140.px) } }
            Input(InputType.Text) { placeholder("Regimen"); value(f_regimen); onInput { f_regimen = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(140.px) } }
            Input(InputType.Text) { placeholder("Estado"); value(f_estado); onInput { f_estado = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(120.px) } }
            Button({
                style { padding(8.px, 16.px); backgroundColor(SidebarActiveColor); color(Color.white); property("border", "none"); borderRadius(6.px); cursor("pointer") }
                onClick {
                    if (f_numeroPedimento.isNotBlank()) {
                        scope.launch {
                            client.post("$BACKEND_URL/api/v1/sap/gts/pedimentos") {
                                contentType(ContentType.Application.Json)
                                setBody(CustomsDeclaration(numeroPedimento = f_numeroPedimento, fecha = f_fecha, cliente = f_cliente, paisDestino = f_paisDestino, valorAduana = f_valorAduana, regimen = f_regimen, estado = f_estado))
                            }
                            f_numeroPedimento = ""
                            f_fecha = ""
                            f_cliente = ""
                            f_paisDestino = ""
                            f_valorAduana = ""
                            f_regimen = ""
                            f_estado = ""
                            refresh()
                        }
                    } else {
                        window.alert("Completa el campo obligatorio para agregar el registro.")
                    }
                }
            }) { Text("+ Agregar") }
        }

        if (isLoading) {
            P { Text("Cargando...") }
        } else {
            Table({ style { width(100.percent) } }) {
                Thead { Tr { Th { Text("No. Pedimento") }; Th { Text("Fecha") }; Th { Text("Cliente") }; Th { Text("Pais Destino") }; Th { Text("Valor Aduana") }; Th { Text("Regimen") }; Th { Text("Estado") }; Th { Text("") } } }
                Tbody {
                    items.forEach { row ->
                        Tr {
                            Td { Text(row.numeroPedimento) }; Td { Text(row.fecha) }; Td { Text(row.cliente) }; Td { Text(row.paisDestino) }; Td { Text(row.valorAduana) }; Td { Text(row.regimen) }; Td { Text(row.estado) }
                            Td {
                                Button({
                                    style { backgroundColor(Color("#ef4444")); color(Color.white); property("border", "none"); borderRadius(4.px); padding(4.px, 10.px); cursor("pointer") }
                                    onClick { scope.launch { client.delete("$BACKEND_URL/api/v1/sap/gts/pedimentos/${row.id}"); refresh() } }
                                }) { Text("Eliminar") }
                            }
                        }
                    }
                }
            }
        }
    }
}

/** División del módulo EHS en pilares, según el dueño: seguridad, salud ocupacional y medio ambiente. */
enum class EhsPillar(val titulo: String, val descripcion: String) {
    SEGURIDAD("Seguridad", "Auditorías internas, incidentes, permisos de trabajo, EPP, capacitación interna, simulacros, matriz de riesgos, químicos, DC-3, dictámenes y normativa."),
    SALUD("Salud Ocupacional", "Registros de salud ocupacional (acceso restringido a Seguridad)."),
    AMBIENTE("Medio Ambiente", "Residuos, huella de carbono y estudios ambientales.")
}

private val ehsPillarTabs: Map<EhsPillar, List<Pair<Int, String>>> = mapOf(
    EhsPillar.SEGURIDAD to listOf(
        0 to "Auditoría Interna", 1 to "Incidentes", 2 to "Permisos Trabajo", 3 to "EPP",
        4 to "Capacitación Interna", 5 to "Simulacros", 6 to "Matriz Riesgos",
        10 to "Químicos", 14 to "DC-3", 15 to "Checklists", 12 to "Dictámenes", 13 to "Normativa"
    ),
    EhsPillar.SALUD to listOf(9 to "Salud Ocupacional"),
    EhsPillar.AMBIENTE to listOf(7 to "Residuos", 8 to "Huella de Carbono", 11 to "Estudios")
)

@Composable
fun EhsAuditsModule(client: HttpClient, scope: kotlinx.coroutines.CoroutineScope, t: Translations, role: UserRole, pillar: EhsPillar) {
    var activeTab by remember { mutableStateOf(0) }
    val tabs = ehsPillarTabs.getValue(pillar)

    Div({ style { backgroundColor(Color.white); padding(32.px); borderRadius(12.px); property("box-shadow", CardShadow) } }) {
        H3({ style { margin(0.px); marginBottom(4.px) } }) { Text("EHS \u00b7 ${pillar.titulo}") }
        P({ style { margin(0.px, 0.px, 16.px, 0.px); color(Color("#64748b")); fontSize(13.px) } }) { Text(pillar.descripcion) }
        AutoRegisterFromEvidencePanel(client, scope)

        // Tab bar
        Div({ style { display(DisplayStyle.Flex); gap(4.px); marginBottom(20.px); flexWrap(FlexWrap.Wrap) } }) {
            tabs.forEachIndexed { idx, (_, label) ->
                Button({
                    style {
                        padding(8.px, 14.px); borderRadius(6.px); cursor("pointer")
                        property("border", "none")
                        if (idx == activeTab) { backgroundColor(SidebarActiveColor); color(Color.white) } else { backgroundColor(Color("#f1f5f9")); color(Color("#475569")) }
                    }
                    onClick { activeTab = idx }
                }) { Text(label) }
            }
        }

        when (tabs[activeTab].first) {
            0 -> EhsInspectionsTab(client, scope)
            1 -> EhsIncidentsTab(client, scope)
            2 -> EhsWorkPermitsTab(client, scope)
            3 -> EhsPpeTab(client, scope)
            4 -> EhsTrainingsTab(client, scope)
            5 -> EhsDrillsTab(client, scope)
            6 -> EhsRiskMatrixTab(client, scope)
            7 -> EhsEnvironmentTab(client, scope)
            8 -> CarbonFootprintTab(client, scope)
            9 -> if (role == UserRole.ADMIN || role == UserRole.SEGURIDAD) EhsOccupationalHealthTab(client, scope)
                else P { Text("Solo Seguridad puede consultar evidencias médicas.") }
            10 -> EhsChemicalsTab(client, scope)
            11 -> EhsCategoryEvidence(client, "Estudio")
            12 -> EhsCategoryEvidence(client, "Dictamen")
            13 -> EhsCategoryEvidence(client, "Normativa")
            14 -> EhsDc3Tab(client, scope)
            15 -> EhsChecklistsTab(client, scope)
            else -> P { Text("Sección no disponible.") }
        }
    }
}

// EHS-8. Medio Ambiente (Residuos)
@Composable
fun EhsEnvironmentTab(client: HttpClient, scope: kotlinx.coroutines.CoroutineScope) {
    var items by remember { mutableStateOf(emptyList<WasteManifest>()) }
    var evidence by remember { mutableStateOf(emptyList<EhsDocument>()) }
    var isLoading by remember { mutableStateOf(true) }
    var refreshKey by remember { mutableStateOf(0) }
    LaunchedEffect(refreshKey) {
        isLoading = true
        try {
            items = client.get("$BACKEND_URL/api/v1/sap/ehs/residuos").body()
            evidence = client.get("$BACKEND_URL/api/v1/ehs/documentos?categoria=Residuos").body()
        } catch (e: Exception) { println("Err: ${e.message}") } finally { isLoading = false }
    }
    fun refresh() { refreshKey++ }

    var f_fecha by remember { mutableStateOf("") }
    var f_residuo by remember { mutableStateOf("") }
    var f_tipo by remember { mutableStateOf("") }
    var f_cantidad by remember { mutableStateOf("") }
    var f_transportista by remember { mutableStateOf("") }
    var f_destino by remember { mutableStateOf("") }
    var f_manifiesto by remember { mutableStateOf("") }

    Span({ style { color(Color.gray); fontSize(13.px); marginBottom(8.px); display(DisplayStyle.Block) } }) { Text("${items.size} manifiestos registrados") }
    Div({ style { display(DisplayStyle.Flex); gap(8.px); marginBottom(16.px); flexWrap(FlexWrap.Wrap); alignItems(AlignItems.Center) } }) {
        Input(InputType.Text) { placeholder("Fecha *"); value(f_fecha); onInput { f_fecha = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(120.px) } }
        Input(InputType.Text) { placeholder("Residuo *"); value(f_residuo); onInput { f_residuo = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(180.px) } }
        Input(InputType.Text) { placeholder("Tipo"); value(f_tipo); onInput { f_tipo = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(140.px) } }
        Input(InputType.Text) { placeholder("Cant"); value(f_cantidad); onInput { f_cantidad = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(80.px) } }
        Input(InputType.Text) { placeholder("Transportista"); value(f_transportista); onInput { f_transportista = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(160.px) } }
        Input(InputType.Text) { placeholder("Destino Final"); value(f_destino); onInput { f_destino = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(160.px) } }
        Input(InputType.Text) { placeholder("No. Manifiesto"); value(f_manifiesto); onInput { f_manifiesto = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(140.px) } }
        Button({
            style { padding(8.px, 16.px); backgroundColor(SidebarActiveColor); color(Color.white); property("border", "none"); borderRadius(6.px); cursor("pointer") }
            onClick {
                if (f_fecha.isNotBlank() && f_residuo.isNotBlank()) {
                    scope.launch {
                        client.post("$BACKEND_URL/api/v1/sap/ehs/residuos") {
                            contentType(ContentType.Application.Json)
                            setBody(WasteManifest(fecha = f_fecha, residuo = f_residuo, tipo = f_tipo, cantidad = f_cantidad, transportista = f_transportista, destinoFinal = f_destino, numeroManifiesto = f_manifiesto))
                        }
                        f_fecha = ""; f_residuo = ""; f_tipo = ""; f_cantidad = ""; f_transportista = ""; f_destino = ""; f_manifiesto = ""; refresh()
                    }
                }
            }
        }) { Text("+ Registrar") }
    }
    if (isLoading) { P { Text("Cargando...") } } else {
        Table({ style { width(100.percent) } }) {
            Thead { Tr { Th { Text("Fecha") }; Th { Text("Residuo") }; Th { Text("Tipo") }; Th { Text("Cant") }; Th { Text("Transportista") }; Th { Text("Destino") }; Th { Text("Manifiesto") }; Th { Text("Evidencias") }; Th { Text("") } } }
            Tbody {
                items.forEach { row -> Tr { Td { Text(row.fecha) }; Td { Text(row.residuo) }; Td { Text(row.tipo) }; Td { Text(row.cantidad) }; Td { Text(row.transportista) }; Td { Text(row.destinoFinal) }; Td { Text(row.numeroManifiesto) }; Td { EhsEvidenceButtons(evidence.filter { it.moduleRecordId == row.id }) }; Td { Button({ style { backgroundColor(Color("#ef4444")); color(Color.white); property("border", "none"); borderRadius(4.px); padding(4.px, 10.px); cursor("pointer") }; onClick { scope.launch { client.delete("$BACKEND_URL/api/v1/sap/ehs/residuos/${row.id}"); refresh() } } }) { Text("X") } } } }
                EhsPendingEvidenceRows(evidence, colSpan = 9, moduleType = "waste", linkTargets = items.map { it.id to "${it.residuo} · ${it.fecha}" }, client = client, scope = scope, onLinked = { refresh() })
            }
        }
    }
}

// EHS-9. Salud Ocupacional (Examenes)
@Composable
fun EhsOccupationalHealthTab(client: HttpClient, scope: kotlinx.coroutines.CoroutineScope) {
    var items by remember { mutableStateOf(emptyList<MedicalExam>()) }
    var evidence by remember { mutableStateOf(emptyList<EhsDocument>()) }
    // Personal del modulo de RH: el desplegable evita teclear IDs y nombres a mano.
    var employees by remember { mutableStateOf(emptyList<Employee>()) }
    var isLoading by remember { mutableStateOf(true) }
    var refreshKey by remember { mutableStateOf(0) }
    LaunchedEffect(refreshKey) {
        isLoading = true
        try {
            items = client.get("$BACKEND_URL/api/v1/sap/ehs/salud").body()
            evidence = client.get("$BACKEND_URL/api/v1/ehs/documentos?categoria=ExamenMedico").body()
            employees = client.get("$BACKEND_URL/api/employees").body()
        } catch (e: Exception) { println("Err: ${e.message}") } finally { isLoading = false }
    }
    fun refresh() { refreshKey++ }

    var f_empId by remember { mutableStateOf("") }
    var f_nombre by remember { mutableStateOf("") }
    var f_fecha by remember { mutableStateOf("") }
    var f_tipo by remember { mutableStateOf("") }
    var f_resultado by remember { mutableStateOf("") }
    var f_prox by remember { mutableStateOf("") }

    Span({ style { color(Color.gray); fontSize(13.px); marginBottom(8.px); display(DisplayStyle.Block) } }) { Text("${items.size} examenes registrados") }
    Div({ style { display(DisplayStyle.Flex); gap(8.px); marginBottom(16.px); flexWrap(FlexWrap.Wrap); alignItems(AlignItems.Center) } }) {
        Select({
            style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(260.px) }
            onChange {
                val emp = employees.firstOrNull { e -> e.id == it.value }
                if (emp != null) { f_empId = emp.id; f_nombre = "${emp.firstName} ${emp.lastName}".trim() }
                else { f_empId = ""; f_nombre = "" }
            }
        }) {
            Option("") { Text("Selecciona trabajador *") }
            employees.forEach { e -> Option(e.id) { Text("${e.id} · ${e.firstName} ${e.lastName}".trim()) } }
        }
        FechaInput(f_fecha, { f_fecha = it }, width = 130)
        Input(InputType.Text) { placeholder("Tipo (Ingreso/Periodico)"); value(f_tipo); onInput { f_tipo = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(160.px) } }
        Input(InputType.Text) { placeholder("Resultado (Apto/...)"); value(f_resultado); onInput { f_resultado = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(140.px) } }
        FechaInput(f_prox, { f_prox = it }, width = 130)
        Button({
            style { padding(8.px, 16.px); backgroundColor(SidebarActiveColor); color(Color.white); property("border", "none"); borderRadius(6.px); cursor("pointer") }
            onClick {
                if (f_empId.isNotBlank() && f_fecha.isNotBlank()) {
                    scope.launch {
                        client.post("$BACKEND_URL/api/v1/sap/ehs/salud") {
                            contentType(ContentType.Application.Json)
                            setBody(MedicalExam(empleadoId = f_empId, nombreEmpleado = f_nombre, fecha = f_fecha, tipoExamen = f_tipo, resultado = f_resultado, proximaCita = f_prox))
                        }
                        f_empId = ""; f_nombre = ""; f_fecha = ""; f_tipo = ""; f_resultado = ""; f_prox = ""; refresh()
                    }
                }
            }
        }) { Text("+ Registrar") }
    }
    if (isLoading) { P { Text("Cargando...") } } else {
        Table({ style { width(100.percent) } }) {
            Thead { Tr { Th { Text("ID Emp") }; Th { Text("Nombre") }; Th { Text("Fecha") }; Th { Text("Tipo") }; Th { Text("Resultado") }; Th { Text("Prox. Cita") }; Th { Text("Evidencias") }; Th { Text("") } } }
            Tbody {
                items.forEach { row -> Tr { Td { Text(row.empleadoId) }; Td { Text(row.nombreEmpleado) }; Td { Text(row.fecha) }; Td { Text(row.tipoExamen) }; Td { Text(row.resultado) }; Td { Text(row.proximaCita) }; Td { EhsEvidenceButtons(evidence.filter { it.moduleRecordId == row.id }) }; Td { Button({ style { backgroundColor(Color("#ef4444")); color(Color.white); property("border", "none"); borderRadius(4.px); padding(4.px, 10.px); cursor("pointer") }; onClick { scope.launch { client.delete("$BACKEND_URL/api/v1/sap/ehs/salud/${row.id}"); refresh() } } }) { Text("X") } } } }
                EhsPendingEvidenceRows(evidence, colSpan = 8, moduleType = "health", linkTargets = items.map { it.id to "${it.nombreEmpleado.trim()} (${it.empleadoId}) · ${it.fecha}" }, client = client, scope = scope, onLinked = { refresh() })
            }
        }
    }
}

// EHS-10. Quimicos (MSDS)
@Composable
fun EhsChemicalsTab(client: HttpClient, scope: kotlinx.coroutines.CoroutineScope) {
    var items by remember { mutableStateOf(emptyList<ChemicalProduct>()) }
    var evidence by remember { mutableStateOf(emptyList<EhsDocument>()) }
    var isLoading by remember { mutableStateOf(true) }
    var refreshKey by remember { mutableStateOf(0) }
    LaunchedEffect(refreshKey) {
        isLoading = true
        try {
            items = client.get("$BACKEND_URL/api/v1/sap/ehs/quimicos").body()
            evidence = client.get("$BACKEND_URL/api/v1/ehs/documentos?categoria=Quimicos").body()
        } catch (e: Exception) { println("Err: ${e.message}") } finally { isLoading = false }
    }
    fun refresh() { refreshKey++ }

    var f_nombre by remember { mutableStateOf("") }
    var f_fabricante by remember { mutableStateOf("") }
    var f_area by remember { mutableStateOf("") }
    var f_riesgo by remember { mutableStateOf("") }
    var f_url by remember { mutableStateOf("") }

    Span({ style { color(Color.gray); fontSize(13.px); marginBottom(8.px); display(DisplayStyle.Block) } }) { Text("${items.size} productos químicos") }
    Div({ style { display(DisplayStyle.Flex); gap(8.px); marginBottom(16.px); flexWrap(FlexWrap.Wrap); alignItems(AlignItems.Center) } }) {
        Input(InputType.Text) { placeholder("Producto *"); value(f_nombre); onInput { f_nombre = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(180.px) } }
        Input(InputType.Text) { placeholder("Fabricante"); value(f_fabricante); onInput { f_fabricante = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(160.px) } }
        Input(InputType.Text) { placeholder("Area uso"); value(f_area); onInput { f_area = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(140.px) } }
        Input(InputType.Text) { placeholder("Nivel Riesgo (0-4)"); value(f_riesgo); onInput { f_riesgo = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(120.px) } }
        Input(InputType.Text) { placeholder("URL Hoja Seguridad"); value(f_url); onInput { f_url = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(220.px) } }
        Button({
            style { padding(8.px, 16.px); backgroundColor(SidebarActiveColor); color(Color.white); property("border", "none"); borderRadius(6.px); cursor("pointer") }
            onClick {
                if (f_nombre.isNotBlank()) {
                    scope.launch {
                        client.post("$BACKEND_URL/api/v1/sap/ehs/quimicos") {
                            contentType(ContentType.Application.Json)
                            setBody(ChemicalProduct(nombre = f_nombre, fabricante = f_fabricante, areaUso = f_area, nivelRiesgo = f_riesgo, hojaSeguridadUrl = f_url))
                        }
                        f_nombre = ""; f_fabricante = ""; f_area = ""; f_riesgo = ""; f_url = ""; refresh()
                    }
                }
            }
        }) { Text("+ Agregar") }
    }
    if (isLoading) { P { Text("Cargando...") } } else {
        Table({ style { width(100.percent) } }) {
            Thead { Tr { Th { Text("Producto") }; Th { Text("Fabricante") }; Th { Text("Area") }; Th { Text("Riesgo") }; Th { Text("MSDS / Evidencia") }; Th { Text("") } } }
            Tbody {
                items.forEach { row -> Tr { Td { Text(row.nombre) }; Td { Text(row.fabricante) }; Td { Text(row.areaUso) }; Td { Text(row.nivelRiesgo) }; Td {
                    val linked = evidence.filter { it.moduleRecordId == row.id }
                    if (linked.isNotEmpty()) EhsEvidenceButtons(linked)
                    else if (row.hojaSeguridadUrl.isNotEmpty()) A(href = row.hojaSeguridadUrl) { Text("Ver PDF") }
                    else Text("-")
                }; Td { Button({ style { backgroundColor(Color("#ef4444")); color(Color.white); property("border", "none"); borderRadius(4.px); padding(4.px, 10.px); cursor("pointer") }; onClick { scope.launch { client.delete("$BACKEND_URL/api/v1/sap/ehs/quimicos/${row.id}"); refresh() } } }) { Text("X") } } } }
                EhsPendingEvidenceRows(evidence, colSpan = 6, moduleType = "chemical", linkTargets = items.map { it.id to "${it.nombre} · ${it.fabricante}" }, client = client, scope = scope, onLinked = { refresh() })
            }
        }
    }
}

// EHS-1. Auditoría Interna (antes Inspecciones)
// Lee un PDF, Word o Excel sin almacenarlo; devuelve filas para revisión humana.
private suspend fun previewDocument(file: org.w3c.files.File): List<List<String>> =
    suspendCoroutine { continuation ->
        val form = js("new FormData()")
        form.append("file", file, file.name)
        val options = js("({})")
        options.method = "POST"
        options.headers = js("({})")
        options.headers.Authorization = "Bearer $apiAuthToken"
        options.body = form
        window.asDynamic().fetch("$BACKEND_URL/api/v1/documentos/extraer", options).then(
            { response: dynamic ->
                response.json().then({ result: dynamic ->
                    if (!response.ok) {
                        continuation.resumeWithException(IllegalStateException(result.message?.toString() ?: "Error HTTP ${response.status}"))
                    } else {
                        val data: dynamic = result.rows
                        val rows = (0 until (data.length as Int)).map { i ->
                            val row: dynamic = data[i]
                            (0 until (row.length as Int)).map { j -> row[j].toString() }
                        }
                        continuation.resume(rows)
                    }
                }, { _: dynamic -> continuation.resumeWithException(IllegalStateException("Respuesta ilegible")) })
            },
            { _: dynamic -> continuation.resumeWithException(IllegalStateException("Error de red")) }
        )
    }

@Composable
fun EhsInspectionsTab(client: HttpClient, scope: kotlinx.coroutines.CoroutineScope) {
    var items by remember { mutableStateOf(emptyList<SafetyInspection>()) }
    var evidence by remember { mutableStateOf(emptyList<EhsDocument>()) }
    var isLoading by remember { mutableStateOf(true) }
    var refreshKey by remember { mutableStateOf(0) }
    var fecha by remember { mutableStateOf("") }
    var tipo by remember { mutableStateOf("") }
    var area by remember { mutableStateOf("") }
    var inspector by remember { mutableStateOf("") }
    var hallazgos by remember { mutableStateOf("") }
    var riesgo by remember { mutableStateOf("") }
    var acciones by remember { mutableStateOf("") }
    var cierre by remember { mutableStateOf("") }
    var estado by remember { mutableStateOf("") }
    var previewRows by remember { mutableStateOf(emptyList<List<String>>()) }
    var previewName by remember { mutableStateOf("") }
    var busy by remember { mutableStateOf(false) }
    var error by remember { mutableStateOf("") }
    LaunchedEffect(refreshKey) {
        isLoading = true
        try {
            items = client.get("$BACKEND_URL/api/v1/sap/ehs/inspecciones").body()
            // Esta pestana antes solo traia evidencia de categoria "Inspeccion",
            // por lo que los documentos subidos como "Auditoria" (p. ej. el
            // catalogo de evidencia documental) nunca aparecian aqui aunque
            // estuvieran vinculados o pendientes de vincular.
            val evInspecciones: List<EhsDocument> = client.get("$BACKEND_URL/api/v1/ehs/documentos?categoria=Inspeccion").body()
            val evAuditorias: List<EhsDocument> = client.get("$BACKEND_URL/api/v1/ehs/documentos?categoria=Auditoria").body()
            evidence = evInspecciones + evAuditorias
        } catch (e: Exception) { error = e.message ?: "Error cargando auditorías" } finally { isLoading = false }
    }
    fun refresh() { refreshKey++ }
    fun fillFromRow(row: List<String>) {
        if (previewRows.isEmpty()) return
        val headers = previewRows.first().map { it.trim().lowercase() }
        fun value(vararg words: String): String {
            val index = headers.indexOfFirst { heading -> words.any { heading.contains(it) } }
            return row.getOrNull(index)?.takeIf { index >= 0 }?.trim().orEmpty()
        }
        // Sólo sugiere campos si la primera fila contiene encabezados reconocibles.
        if (headers.none { it.contains("fecha") || it.contains("inspector") || it.contains("área") || it.contains("area") }) {
            error = "No se reconocieron encabezados. Usa la vista previa para capturar manualmente."
            return
        }
        fecha = value("fecha")
        tipo = value("tipo")
        area = value("área", "area")
        inspector = value("inspector", "responsable")
        hallazgos = value("hallazgo", "observaci")
        riesgo = value("riesgo")
        acciones = value("acci")
        cierre = value("cierre")
        estado = value("estado", "estatus")
        error = "Campos sugeridos a partir de una fila. Comprueba y corrige antes de guardar."
    }
    Span({ style { color(Color.gray); fontSize(13.px); marginBottom(8.px); display(DisplayStyle.Block) } }) { Text("${items.size} registros") }
    Div({ style { marginBottom(16.px) } }) {
        H4 { Text("Nueva auditoría interna") }
        P { Text("Captura manualmente o carga un PDF, Word (.docx) o Excel (.xlsx/.xls) para revisar sus datos. El archivo no se guarda al analizarlo; las evidencias se suben por separado en Evidencia Documental.") }
        Div({ style { display(DisplayStyle.Flex); gap(8.px); flexWrap(FlexWrap.Wrap); marginBottom(10.px) } }) {
            FechaInput(fecha, { fecha = it }, width = 130)
            Input(InputType.Text) { placeholder("Tipo de auditoría"); value(tipo); onInput { tipo = it.value } }
            Input(InputType.Text) { placeholder("Auditor"); value(inspector); onInput { inspector = it.value } }
        }
        P({ style { fontSize(12.px); color(Color("#64748b")); marginTop(-4.px) } }) {
            Text("Área, hallazgos, riesgo, acciones correctivas, fecha de cierre y estado se completan despues con el boton \"Editar\" de cada fila, una vez realizada la auditoria.")
        }
        Button({ onClick {
            if (busy) return@onClick
            if (fecha.isBlank()) { error = "La fecha es obligatoria."; return@onClick }
            busy = true
            scope.launch {
                try {
                    val response = client.post("$BACKEND_URL/api/v1/sap/ehs/inspecciones") {
                        contentType(ContentType.Application.Json)
                        setBody(SafetyInspection(fecha = fecha, tipoInspeccion = tipo, inspector = inspector,
                            estado = "Pendiente de revision"))
                    }
                    if (response.status != HttpStatusCode.Created) error = "No se pudo guardar: HTTP ${response.status}"
                    else {
                        fecha = ""; tipo = ""; inspector = ""
                        error = "Auditoria guardada. Completa el resto con \"Editar\" cuando termines de realizarla."; refresh()
                    }
                } catch (e: Exception) { error = e.message ?: "No se pudo guardar la inspección" }
                finally { busy = false }
            }
        } }) { Text(if (busy) "Guardando..." else "+ Guardar inspección") }
        Div({ style { marginTop(14.px) } }) {
            Input(InputType.File) {
                id("inspection-import-file")
                attr("accept", ".pdf,.docx,.xlsx,.xls")
                onChange {
                    val file = (document.getElementById("inspection-import-file") as? HTMLInputElement)?.files?.item(0)
                    if (file != null) {
                        if (file.size.toLong() > 15L * 1024 * 1024) { error = "Máximo 15 MiB por archivo." }
                        else {
                            busy = true; error = "Extrayendo texto del documento..."
                            scope.launch {
                                try { previewRows = previewDocument(file); previewName = file.name; error = "Revisa los datos extraídos antes de crear registros." }
                                catch (e: Exception) { previewRows = emptyList(); error = e.message ?: "No se pudo leer el documento" }
                                finally { busy = false }
                            }
                        }
                    }
                }
            }
        }
        if (error.isNotBlank()) P { Text(error) }
        if (previewRows.isNotEmpty()) {
            H4 { Text("Vista previa: $previewName (${previewRows.size} filas mostradas)") }
            P { Text("Pulsa Usar fila para sugerir campos. Nada de esta tabla se guarda automáticamente.") }
            Table {
                Tbody {
                    previewRows.take(50).forEachIndexed { i, row ->
                        Tr {
                            Td { Text(row.joinToString(" | ").take(800)) }
                            Td { if (i > 0) Button({ onClick { fillFromRow(row) } }) { Text("Usar fila") } }
                        }
                    }
                }
            }
            if (previewRows.size > 50) P { Text("Mostrando las primeras 50 filas; el archivo puede contener más.") }
        }
    }
    var editingId by remember { mutableStateOf(0) }
    var e_area by remember { mutableStateOf("") }
    var e_inspector by remember { mutableStateOf("") }
    var e_hallazgos by remember { mutableStateOf("") }
    var e_riesgo by remember { mutableStateOf("") }
    var e_acciones by remember { mutableStateOf("") }
    var e_cierre by remember { mutableStateOf("") }
    var e_estado by remember { mutableStateOf("Pendiente de revision") }
    var e_busy by remember { mutableStateOf(false) }
    fun startEdit(row: SafetyInspection) {
        editingId = row.id
        e_area = row.area; e_inspector = row.inspector; e_hallazgos = row.hallazgos; e_riesgo = row.riesgo
        e_acciones = row.accionesCorrectivas; e_cierre = row.fechaCierre
        e_estado = row.estado.ifBlank { "Pendiente de revision" }
    }
    fun saveEdit(row: SafetyInspection) {
        if (e_busy) return
        e_busy = true
        scope.launch {
            try {
                val resp = client.put("$BACKEND_URL/api/v1/sap/ehs/inspecciones/${row.id}") {
                    contentType(ContentType.Application.Json)
                    setBody(row.copy(area = e_area, inspector = e_inspector, hallazgos = e_hallazgos, riesgo = e_riesgo,
                        accionesCorrectivas = e_acciones, fechaCierre = e_cierre, estado = e_estado))
                }
                if (resp.status.value in 200..299) { editingId = 0; refresh() }
                else error = "No se pudo guardar la edicion: HTTP ${resp.status}"
            } catch (ex: Exception) { error = ex.message ?: "No se pudo guardar la edicion" }
            finally { e_busy = false }
        }
    }
    if (isLoading) { P { Text("Cargando...") } } else {
        Table({ style { width(100.percent) } }) {
            Thead { Tr { Th { Text("Fecha") }; Th { Text("Tipo") }; Th { Text("Area") }; Th { Text("Inspector") }; Th { Text("Hallazgos") }; Th { Text("Riesgo") }; Th { Text("Acciones") }; Th { Text("F.Cierre") }; Th { Text("Estado") }; Th { Text("Evidencias") }; Th { Text("") } } }
            Tbody {
                items.forEach { row ->
                    if (editingId == row.id) {
                        Tr({ style { backgroundColor(Color("#eff6ff")) } }) {
                            Td { Text(row.fecha) }
                            Td { Text(row.tipoInspeccion) }
                            Td { Input(InputType.Text) { placeholder("Área"); value(e_area); onInput { e_area = it.value }; style { width(100.percent); padding(4.px) } } }
                            Td { Input(InputType.Text) { placeholder("Inspector"); value(e_inspector); onInput { e_inspector = it.value }; style { width(100.percent); padding(4.px) } } }
                            Td { Input(InputType.Text) { placeholder("Hallazgos"); value(e_hallazgos); onInput { e_hallazgos = it.value }; style { width(100.percent); padding(4.px) } } }
                            Td { Input(InputType.Text) { placeholder("Riesgo"); value(e_riesgo); onInput { e_riesgo = it.value }; style { width(100.percent); padding(4.px) } } }
                            Td { Input(InputType.Text) { placeholder("Acciones correctivas"); value(e_acciones); onInput { e_acciones = it.value }; style { width(100.percent); padding(4.px) } } }
                            Td { FechaInput(e_cierre, { e_cierre = it }, width = 110) }
                            Td {
                                Select({
                                    style { padding(4.px); borderRadius(4.px); property("border", "1px solid #cbd5e1") }
                                    onChange { e_estado = it.value ?: "Pendiente de revision" }
                                }) {
                                    listOf("Pendiente de revision", "Abierto", "Cerrado").forEach { opt ->
                                        Option(opt, { if (opt == e_estado) selected() }) { Text(opt) }
                                    }
                                }
                            }
                            Td { EhsEvidenceButtons(evidence.filter { it.moduleRecordId == row.id }) }
                            Td {
                                Div({ style { display(DisplayStyle.Flex); gap(4.px) } }) {
                                    Button({ style { backgroundColor(Color("#059669")); color(Color.white); property("border", "none"); borderRadius(4.px); padding(4.px, 8.px); cursor("pointer"); fontSize(11.px) }; onClick { saveEdit(row) } }) { Text(if (e_busy) "..." else "Guardar") }
                                    Button({ style { backgroundColor(Color("#64748b")); color(Color.white); property("border", "none"); borderRadius(4.px); padding(4.px, 8.px); cursor("pointer"); fontSize(11.px) }; onClick { editingId = 0 } }) { Text("Cancelar") }
                                }
                            }
                        }
                    } else {
                        Tr {
                            Td { Text(row.fecha) }; Td { Text(row.tipoInspeccion) }; Td { Text(row.area) }; Td { Text(row.inspector) }; Td { Text(row.hallazgos) }; Td { Text(row.riesgo) }; Td { Text(row.accionesCorrectivas) }; Td { Text(row.fechaCierre) }; Td { Text(row.estado) }
                            Td { EhsEvidenceButtons(evidence.filter { it.moduleRecordId == row.id }) }
                            Td {
                                Div({ style { display(DisplayStyle.Flex); gap(4.px) } }) {
                                    Button({ style { backgroundColor(Color("#2563eb")); color(Color.white); property("border", "none"); borderRadius(4.px); padding(4.px, 8.px); cursor("pointer"); fontSize(11.px) }; onClick { startEdit(row) } }) { Text("Editar") }
                                    Button({ style { backgroundColor(Color("#ef4444")); color(Color.white); property("border", "none"); borderRadius(4.px); padding(4.px, 10.px); cursor("pointer") }; onClick { scope.launch { client.delete("$BACKEND_URL/api/v1/sap/ehs/inspecciones/${row.id}"); refresh() } } }) { Text("X") }
                                }
                            }
                        }
                    }
                }
                EhsPendingEvidenceRows(evidence, colSpan = 11, moduleType = "inspection", linkTargets = items.map { it.id to "${it.tipoInspeccion} · ${it.area} · ${it.fecha}" }, client = client, scope = scope, onLinked = { refresh() })
            }
        }
    }
}

// EHS-2. Incidentes y Accidentes
@Composable
fun EhsIncidentsTab(client: HttpClient, scope: kotlinx.coroutines.CoroutineScope) {
    var items by remember { mutableStateOf(emptyList<SafetyIncident>()) }
    var evidence by remember { mutableStateOf(emptyList<EhsDocument>()) }
    var isLoading by remember { mutableStateOf(true) }
    var refreshKey by remember { mutableStateOf(0) }
    LaunchedEffect(refreshKey) { isLoading = true; try {
        items = client.get("$BACKEND_URL/api/v1/sap/ehs/incidentes").body()
        evidence = client.get("$BACKEND_URL/api/v1/ehs/documentos?categoria=Incidente").body()
    } catch (e: Exception) { println("Err: ${e.message}") } finally { isLoading = false } }
    fun refresh() { refreshKey++ }
    var f_fecha by remember { mutableStateOf("") }
    var f_tipo by remember { mutableStateOf("") }
    var f_severidad by remember { mutableStateOf("") }
    var f_personaAfectada by remember { mutableStateOf("") }
    var f_departamento by remember { mutableStateOf("") }
    var f_parteCuerpo by remember { mutableStateOf("") }
    var f_diasPerdidos by remember { mutableStateOf("") }
    var f_descripcion by remember { mutableStateOf("") }
    var f_causaRaiz by remember { mutableStateOf("") }
    var f_estado by remember { mutableStateOf("") }
    Span({ style { color(Color.gray); fontSize(13.px); marginBottom(8.px); display(DisplayStyle.Block) } }) { Text("${items.size} registros") }
    Div({ style { display(DisplayStyle.Flex); gap(8.px); marginBottom(16.px); flexWrap(FlexWrap.Wrap); alignItems(AlignItems.Center) } }) {
        Input(InputType.Text) { placeholder("Fecha *"); value(f_fecha); onInput { f_fecha = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(120.px) } }
        Input(InputType.Text) { placeholder("Tipo (Accidente/Incidente/Casi)"); value(f_tipo); onInput { f_tipo = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(200.px) } }
        Input(InputType.Text) { placeholder("Severidad (Leve/Mod/Grave/Fatal)"); value(f_severidad); onInput { f_severidad = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(200.px) } }
        Input(InputType.Text) { placeholder("Persona afectada"); value(f_personaAfectada); onInput { f_personaAfectada = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(160.px) } }
        Input(InputType.Text) { placeholder("Departamento"); value(f_departamento); onInput { f_departamento = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(140.px) } }
        Input(InputType.Text) { placeholder("Parte cuerpo"); value(f_parteCuerpo); onInput { f_parteCuerpo = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(140.px) } }
        Input(InputType.Text) { placeholder("Dias perdidos"); value(f_diasPerdidos); onInput { f_diasPerdidos = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(100.px) } }
        Input(InputType.Text) { placeholder("Descripcion"); value(f_descripcion); onInput { f_descripcion = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(200.px) } }
        Input(InputType.Text) { placeholder("Causa raiz"); value(f_causaRaiz); onInput { f_causaRaiz = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(200.px) } }
        Input(InputType.Text) { placeholder("Estado"); value(f_estado); onInput { f_estado = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(100.px) } }
        Button({ style { padding(8.px, 16.px); backgroundColor(SidebarActiveColor); color(Color.white); property("border", "none"); borderRadius(6.px); cursor("pointer") }; onClick { if (f_fecha.isNotBlank()) { scope.launch { client.post("$BACKEND_URL/api/v1/sap/ehs/incidentes") { contentType(ContentType.Application.Json); setBody(SafetyIncident(fecha = f_fecha, tipo = f_tipo, severidad = f_severidad, personaAfectada = f_personaAfectada, departamento = f_departamento, parteCuerpo = f_parteCuerpo, diasPerdidos = f_diasPerdidos, descripcion = f_descripcion, causaRaiz = f_causaRaiz, estado = f_estado)) }; f_fecha = ""; f_tipo = ""; f_severidad = ""; f_personaAfectada = ""; f_departamento = ""; f_parteCuerpo = ""; f_diasPerdidos = ""; f_descripcion = ""; f_causaRaiz = ""; f_estado = ""; refresh() } } else { window.alert("La fecha es obligatoria.") } } }) { Text("+ Agregar") }
    }
    if (isLoading) { P { Text("Cargando...") } } else {
        Table({ style { width(100.percent) } }) {
            Thead { Tr { Th { Text("Fecha") }; Th { Text("Tipo") }; Th { Text("Severidad") }; Th { Text("Persona") }; Th { Text("Depto") }; Th { Text("Cuerpo") }; Th { Text("Dias") }; Th { Text("Descripcion") }; Th { Text("Causa") }; Th { Text("Estado") }; Th { Text("Evidencias") }; Th { Text("") } } }
            Tbody {
                items.forEach { row -> Tr { Td { Text(row.fecha) }; Td { Text(row.tipo) }; Td { Text(row.severidad) }; Td { Text(row.personaAfectada) }; Td { Text(row.departamento) }; Td { Text(row.parteCuerpo) }; Td { Text(row.diasPerdidos) }; Td { Text(row.descripcion) }; Td { Text(row.causaRaiz) }; Td { Text(row.estado) }; Td { EhsEvidenceButtons(evidence.filter { it.moduleRecordId == row.id }) }; Td { Button({ style { backgroundColor(Color("#ef4444")); color(Color.white); property("border", "none"); borderRadius(4.px); padding(4.px, 10.px); cursor("pointer") }; onClick { scope.launch { client.delete("$BACKEND_URL/api/v1/sap/ehs/incidentes/${row.id}"); refresh() } } }) { Text("X") } } } }
                EhsPendingEvidenceRows(evidence, colSpan = 12, moduleType = "incident", linkTargets = items.map { it.id to "${it.tipo} · ${it.fecha}" }, client = client, scope = scope, onLinked = { refresh() })
            }
        }
    }
}

// EHS-3. Permisos de Trabajo
@Composable
fun EhsWorkPermitsTab(client: HttpClient, scope: kotlinx.coroutines.CoroutineScope) {
    var items by remember { mutableStateOf(emptyList<WorkPermit>()) }
    var evidence by remember { mutableStateOf(emptyList<EhsDocument>()) }
    var isLoading by remember { mutableStateOf(true) }
    var refreshKey by remember { mutableStateOf(0) }
    LaunchedEffect(refreshKey) { isLoading = true; try {
        items = client.get("$BACKEND_URL/api/v1/sap/ehs/permisos-trabajo").body()
        evidence = client.get("$BACKEND_URL/api/v1/ehs/documentos?categoria=PermisoTrabajo").body()
    } catch (e: Exception) { println("Err: ${e.message}") } finally { isLoading = false } }
    fun refresh() { refreshKey++ }
    var f_tipo by remember { mutableStateOf("") }
    var f_solicitante by remember { mutableStateOf("") }
    var f_autorizadoPor by remember { mutableStateOf("") }
    var f_fechaInicio by remember { mutableStateOf("") }
    var f_fechaFin by remember { mutableStateOf("") }
    var f_area by remember { mutableStateOf("") }
    var f_riesgosIdentificados by remember { mutableStateOf("") }
    var f_eppRequerido by remember { mutableStateOf("") }
    var f_estado by remember { mutableStateOf("") }
    Span({ style { color(Color.gray); fontSize(13.px); marginBottom(8.px); display(DisplayStyle.Block) } }) { Text("${items.size} registros") }
    Div({ style { display(DisplayStyle.Flex); gap(8.px); marginBottom(16.px); flexWrap(FlexWrap.Wrap); alignItems(AlignItems.Center) } }) {
        Input(InputType.Text) { placeholder("Tipo (Caliente/Espacio confinado/Alturas)"); value(f_tipo); onInput { f_tipo = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(220.px) } }
        Input(InputType.Text) { placeholder("Solicitante *"); value(f_solicitante); onInput { f_solicitante = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(150.px) } }
        Input(InputType.Text) { placeholder("Autorizado por"); value(f_autorizadoPor); onInput { f_autorizadoPor = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(150.px) } }
        Input(InputType.Text) { placeholder("F. Inicio"); value(f_fechaInicio); onInput { f_fechaInicio = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(120.px) } }
        Input(InputType.Text) { placeholder("F. Fin"); value(f_fechaFin); onInput { f_fechaFin = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(120.px) } }
        Input(InputType.Text) { placeholder("Area"); value(f_area); onInput { f_area = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(140.px) } }
        Input(InputType.Text) { placeholder("Riesgos identificados"); value(f_riesgosIdentificados); onInput { f_riesgosIdentificados = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(200.px) } }
        Input(InputType.Text) { placeholder("EPP requerido"); value(f_eppRequerido); onInput { f_eppRequerido = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(200.px) } }
        Input(InputType.Text) { placeholder("Estado"); value(f_estado); onInput { f_estado = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(100.px) } }
        Button({ style { padding(8.px, 16.px); backgroundColor(SidebarActiveColor); color(Color.white); property("border", "none"); borderRadius(6.px); cursor("pointer") }; onClick { if (f_solicitante.isNotBlank()) { scope.launch { client.post("$BACKEND_URL/api/v1/sap/ehs/permisos-trabajo") { contentType(ContentType.Application.Json); setBody(WorkPermit(tipo = f_tipo, solicitante = f_solicitante, autorizadoPor = f_autorizadoPor, fechaInicio = f_fechaInicio, fechaFin = f_fechaFin, area = f_area, riesgosIdentificados = f_riesgosIdentificados, eppRequerido = f_eppRequerido, estado = f_estado)) }; f_tipo = ""; f_solicitante = ""; f_autorizadoPor = ""; f_fechaInicio = ""; f_fechaFin = ""; f_area = ""; f_riesgosIdentificados = ""; f_eppRequerido = ""; f_estado = ""; refresh() } } else { window.alert("El solicitante es obligatorio.") } } }) { Text("+ Agregar") }
    }
    if (isLoading) { P { Text("Cargando...") } } else {
        Table({ style { width(100.percent) } }) {
            Thead { Tr { Th { Text("Tipo") }; Th { Text("Solicitante") }; Th { Text("Autorizado") }; Th { Text("F.Inicio") }; Th { Text("F.Fin") }; Th { Text("Area") }; Th { Text("Riesgos") }; Th { Text("EPP") }; Th { Text("Estado") }; Th { Text("Evidencias") }; Th { Text("") } } }
            Tbody {
                items.forEach { row -> Tr { Td { Text(row.tipo) }; Td { Text(row.solicitante) }; Td { Text(row.autorizadoPor) }; Td { Text(row.fechaInicio) }; Td { Text(row.fechaFin) }; Td { Text(row.area) }; Td { Text(row.riesgosIdentificados) }; Td { Text(row.eppRequerido) }; Td { Text(row.estado) }; Td { EhsEvidenceButtons(evidence.filter { it.moduleRecordId == row.id }) }; Td { Button({ style { backgroundColor(Color("#ef4444")); color(Color.white); property("border", "none"); borderRadius(4.px); padding(4.px, 10.px); cursor("pointer") }; onClick { scope.launch { client.delete("$BACKEND_URL/api/v1/sap/ehs/permisos-trabajo/${row.id}"); refresh() } } }) { Text("X") } } } }
                EhsPendingEvidenceRows(evidence, colSpan = 11, moduleType = "permit", linkTargets = items.map { it.id to "${it.tipo} · ${it.solicitante} · ${it.fechaInicio}" }, client = client, scope = scope, onLinked = { refresh() })
            }
        }
    }
}

// EHS-4. Entrega de EPP
@Composable
fun EhsPpeTab(client: HttpClient, scope: kotlinx.coroutines.CoroutineScope) {
    var items by remember { mutableStateOf(emptyList<PpeDelivery>()) }
    var evidence by remember { mutableStateOf(emptyList<EhsDocument>()) }
    var isLoading by remember { mutableStateOf(true) }
    var refreshKey by remember { mutableStateOf(0) }
    LaunchedEffect(refreshKey) { isLoading = true; try {
        items = client.get("$BACKEND_URL/api/v1/sap/ehs/entregas-epp").body()
        evidence = client.get("$BACKEND_URL/api/v1/ehs/documentos?categoria=EPP").body()
    } catch (e: Exception) { println("Err: ${e.message}") } finally { isLoading = false } }
    fun refresh() { refreshKey++ }
    var f_fecha by remember { mutableStateOf("") }
    var f_empleado by remember { mutableStateOf("") }
    var f_tipoEpp by remember { mutableStateOf("") }
    var f_talla by remember { mutableStateOf("") }
    var f_proximaReposicion by remember { mutableStateOf("") }
    var f_firma by remember { mutableStateOf("") }
    Span({ style { color(Color.gray); fontSize(13.px); marginBottom(8.px); display(DisplayStyle.Block) } }) { Text("${items.size} registros") }
    Div({ style { display(DisplayStyle.Flex); gap(8.px); marginBottom(16.px); flexWrap(FlexWrap.Wrap); alignItems(AlignItems.Center) } }) {
        Input(InputType.Text) { placeholder("Fecha *"); value(f_fecha); onInput { f_fecha = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(120.px) } }
        Input(InputType.Text) { placeholder("Empleado *"); value(f_empleado); onInput { f_empleado = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(160.px) } }
        Input(InputType.Text) { placeholder("Tipo EPP (Casco/Lentes/Guantes...)"); value(f_tipoEpp); onInput { f_tipoEpp = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(220.px) } }
        Input(InputType.Text) { placeholder("Talla"); value(f_talla); onInput { f_talla = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(80.px) } }
        Input(InputType.Text) { placeholder("Prox. reposicion"); value(f_proximaReposicion); onInput { f_proximaReposicion = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(130.px) } }
        Input(InputType.Text) { placeholder("Firma"); value(f_firma); onInput { f_firma = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(140.px) } }
        Button({ style { padding(8.px, 16.px); backgroundColor(SidebarActiveColor); color(Color.white); property("border", "none"); borderRadius(6.px); cursor("pointer") }; onClick { if (f_fecha.isNotBlank() && f_empleado.isNotBlank()) { scope.launch { client.post("$BACKEND_URL/api/v1/sap/ehs/entregas-epp") { contentType(ContentType.Application.Json); setBody(PpeDelivery(fecha = f_fecha, empleado = f_empleado, tipoEpp = f_tipoEpp, talla = f_talla, proximaReposicion = f_proximaReposicion, firma = f_firma)) }; f_fecha = ""; f_empleado = ""; f_tipoEpp = ""; f_talla = ""; f_proximaReposicion = ""; f_firma = ""; refresh() } } else { window.alert("Fecha y empleado son obligatorios.") } } }) { Text("+ Agregar") }
    }
    if (isLoading) { P { Text("Cargando...") } } else {
        Table({ style { width(100.percent) } }) {
            Thead { Tr { Th { Text("Fecha") }; Th { Text("Empleado") }; Th { Text("Tipo EPP") }; Th { Text("Talla") }; Th { Text("Prox. Reposicion") }; Th { Text("Firma") }; Th { Text("Evidencias") }; Th { Text("") } } }
            Tbody {
                items.forEach { row -> Tr { Td { Text(row.fecha) }; Td { Text(row.empleado) }; Td { Text(row.tipoEpp) }; Td { Text(row.talla) }; Td { Text(row.proximaReposicion) }; Td { Text(row.firma) }; Td { EhsEvidenceButtons(evidence.filter { it.moduleRecordId == row.id }) }; Td { Button({ style { backgroundColor(Color("#ef4444")); color(Color.white); property("border", "none"); borderRadius(4.px); padding(4.px, 10.px); cursor("pointer") }; onClick { scope.launch { client.delete("$BACKEND_URL/api/v1/sap/ehs/entregas-epp/${row.id}"); refresh() } } }) { Text("X") } } } }
                EhsPendingEvidenceRows(evidence, colSpan = 8, moduleType = "ppe", linkTargets = items.map { it.id to "${it.empleado} · ${it.tipoEpp} · ${it.fecha}" }, client = client, scope = scope, onLinked = { refresh() })
            }
        }
    }
}

// EHS-5. Capacitaciones de Seguridad
@Composable
fun EhsTrainingsTab(client: HttpClient, scope: kotlinx.coroutines.CoroutineScope) {
    var items by remember { mutableStateOf(emptyList<SafetyTraining>()) }
    var evidence by remember { mutableStateOf(emptyList<EhsDocument>()) }
    var isLoading by remember { mutableStateOf(true) }
    var refreshKey by remember { mutableStateOf(0) }
    LaunchedEffect(refreshKey) { isLoading = true; try {
        items = client.get("$BACKEND_URL/api/v1/sap/ehs/capacitaciones").body()
        evidence = client.get("$BACKEND_URL/api/v1/ehs/documentos?categoria=Capacitacion").body()
    } catch (e: Exception) { println("Err: ${e.message}") } finally { isLoading = false } }
    fun refresh() { refreshKey++ }
    var f_fecha by remember { mutableStateOf("") }
    var f_tema by remember { mutableStateOf("") }
    var f_instructor by remember { mutableStateOf("") }
    var f_asistentes by remember { mutableStateOf("") }
    var f_vigenciaMeses by remember { mutableStateOf("") }
    var f_proximaFecha by remember { mutableStateOf("") }
    var f_estado by remember { mutableStateOf("") }
    Span({ style { color(Color.gray); fontSize(13.px); marginBottom(8.px); display(DisplayStyle.Block) } }) { Text("${items.size} registros") }
    Div({ style { display(DisplayStyle.Flex); gap(8.px); marginBottom(16.px); flexWrap(FlexWrap.Wrap); alignItems(AlignItems.Center) } }) {
        Input(InputType.Text) { placeholder("Fecha *"); value(f_fecha); onInput { f_fecha = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(120.px) } }
        Input(InputType.Text) { placeholder("Tema (Extintores/Primeros auxil.)"); value(f_tema); onInput { f_tema = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(220.px) } }
        Input(InputType.Text) { placeholder("Instructor"); value(f_instructor); onInput { f_instructor = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(150.px) } }
        Input(InputType.Text) { placeholder("Asistentes"); value(f_asistentes); onInput { f_asistentes = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(100.px) } }
        Input(InputType.Text) { placeholder("Vigencia (meses)"); value(f_vigenciaMeses); onInput { f_vigenciaMeses = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(120.px) } }
        Input(InputType.Text) { placeholder("Prox. fecha"); value(f_proximaFecha); onInput { f_proximaFecha = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(120.px) } }
        Input(InputType.Text) { placeholder("Estado"); value(f_estado); onInput { f_estado = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(100.px) } }
        Button({ style { padding(8.px, 16.px); backgroundColor(SidebarActiveColor); color(Color.white); property("border", "none"); borderRadius(6.px); cursor("pointer") }; onClick { if (f_fecha.isNotBlank()) { scope.launch { client.post("$BACKEND_URL/api/v1/sap/ehs/capacitaciones") { contentType(ContentType.Application.Json); setBody(SafetyTraining(fecha = f_fecha, tema = f_tema, instructor = f_instructor, asistentes = f_asistentes, vigenciaMeses = f_vigenciaMeses, proximaFecha = f_proximaFecha, estado = f_estado)) }; f_fecha = ""; f_tema = ""; f_instructor = ""; f_asistentes = ""; f_vigenciaMeses = ""; f_proximaFecha = ""; f_estado = ""; refresh() } } else { window.alert("La fecha es obligatoria.") } } }) { Text("+ Agregar") }
    }
    if (isLoading) { P { Text("Cargando...") } } else {
        Table({ style { width(100.percent) } }) {
            Thead { Tr { Th { Text("Fecha") }; Th { Text("Tema") }; Th { Text("Instructor") }; Th { Text("Asist.") }; Th { Text("Vigencia") }; Th { Text("Prox.Fecha") }; Th { Text("Estado") }; Th { Text("Evidencias") }; Th { Text("") } } }
            Tbody {
                items.forEach { row -> Tr { Td { Text(row.fecha) }; Td { Text(row.tema) }; Td { Text(row.instructor) }; Td { Text(row.asistentes) }; Td { Text(row.vigenciaMeses) }; Td { Text(row.proximaFecha) }; Td { Text(row.estado) }; Td { EhsEvidenceButtons(evidence.filter { it.moduleRecordId == row.id }) }; Td { Button({ style { backgroundColor(Color("#ef4444")); color(Color.white); property("border", "none"); borderRadius(4.px); padding(4.px, 10.px); cursor("pointer") }; onClick { scope.launch { client.delete("$BACKEND_URL/api/v1/sap/ehs/capacitaciones/${row.id}"); refresh() } } }) { Text("X") } } } }
                EhsPendingEvidenceRows(evidence, colSpan = 9, moduleType = "training", linkTargets = items.map { it.id to "${it.tema} · ${it.fecha}" }, client = client, scope = scope, onLinked = { refresh() })
            }
        }
    }
}

// EHS-5b. Constancias DC-3 de la capacitación interna
@Composable
fun EhsDc3Tab(client: HttpClient, scope: kotlinx.coroutines.CoroutineScope) {
    var items by remember { mutableStateOf(emptyList<Dc3Constancia>()) }
    // Evidencia subida con la categoria DC3 del catalogo documental. Antes no
    // existia esa categoria y las constancias subidas quedaban huerfanas.
    var evidence by remember { mutableStateOf(emptyList<EhsDocument>()) }
    var employees by remember { mutableStateOf(emptyList<Employee>()) }
    var isLoading by remember { mutableStateOf(true) }
    var refreshKey by remember { mutableStateOf(0) }
    LaunchedEffect(refreshKey) { isLoading = true; try {
        items = client.get("$BACKEND_URL/api/v1/ehs/dc3").body()
        evidence = client.get("$BACKEND_URL/api/v1/ehs/documentos?categoria=DC3").body()
        employees = client.get("$BACKEND_URL/api/employees").body()
    } catch (e: Exception) { println("Err: ${e.message}") } finally { isLoading = false } }
    fun refresh() { refreshKey++ }
    // El responsable por defecto es quien está capturando (el dueño lo definió así).
    // Varios trabajadores a la vez: algunos PDF de DC-3 traen la constancia de
    // VARIAS personas en un mismo documento (un solo curso grupal). Antes solo
    // se podia elegir un trabajador por vez, asi que un PDF grupal obligaba a
    // repetir la carga N veces sin forma de compartir el mismo enlace. Ahora se
    // eligen varios trabajadores con checkboxes y se crea una constancia por
    // cada uno, todas con el mismo tema/fecha/horas/responsable/evidencia.
    var f_trabajadorIds by remember { mutableStateOf(emptySet<String>()) }
    var f_buscarTrabajador by remember { mutableStateOf("") }
    var f_tema by remember { mutableStateOf("") }
    var f_fecha by remember { mutableStateOf("") }
    var f_horas by remember { mutableStateOf("") }
    var f_responsable by remember { mutableStateOf(window.localStorage.getItem("naf_user_name") ?: "") }
    var f_evidencia by remember { mutableStateOf("") }
    var f_busy by remember { mutableStateOf(false) }
    Span({ style { color(Color.gray); fontSize(13.px); marginBottom(8.px); display(DisplayStyle.Block) } }) { Text("${items.size} constancias DC-3 registradas") }
    P({ style { margin(0.px, 0.px, 12.px, 0.px); color(Color("#64748b")); fontSize(13.px) } }) {
        Text("Constancia oficial de habilidades laborales (DC-3). El responsable se registra en cada constancia; la evidencia firmada se enlaza por URL HTTPS de Drive o se vincula desde la categoría DC3 de Evidencia Documental. Si el PDF trae varias personas en un mismo documento (curso grupal), marca a todos los trabajadores de la lista de abajo: se crea una constancia por cada uno con el mismo tema/fecha/enlace.")
    }
    Div({ style { display(DisplayStyle.Flex); gap(8.px); marginBottom(10.px); flexWrap(FlexWrap.Wrap); alignItems(AlignItems.Center) } }) {
        Input(InputType.Text) { placeholder("Tema / curso *"); value(f_tema); onInput { f_tema = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(200.px) } }
        FechaInput(f_fecha, { f_fecha = it }, width = 130)
        Input(InputType.Text) { placeholder("Horas"); value(f_horas); onInput { f_horas = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(80.px) } }
        Input(InputType.Text) { placeholder("Responsable"); value(f_responsable); onInput { f_responsable = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(160.px) } }
        Input(InputType.Text) { placeholder("Enlace evidencia (https, mismo PDF para todos)"); value(f_evidencia); onInput { f_evidencia = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(260.px) } }
    }
    Div({ style { marginBottom(8.px) } }) {
        Input(InputType.Text) { placeholder("Buscar trabajador por nombre o No. empleado..."); value(f_buscarTrabajador); onInput { f_buscarTrabajador = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(320.px) } }
        Span({ style { marginLeft(10.px); fontSize(12.px); color(Color.gray) } }) { Text("${f_trabajadorIds.size} seleccionados") }
        if (f_trabajadorIds.isNotEmpty()) Button({ style { marginLeft(8.px); padding(3.px, 8.px); fontSize(11.px); backgroundColor(Color("#e2e8f0")); property("border", "none"); borderRadius(4.px); cursor("pointer") }; onClick { f_trabajadorIds = emptySet() } }) { Text("Limpiar seleccion") }
    }
    Div({ style { maxHeight(180.px); overflow("auto"); property("border", "1px solid #e2e8f0"); borderRadius(6.px); padding(8.px); marginBottom(12.px); display(DisplayStyle.Flex); flexWrap(FlexWrap.Wrap); gap(6.px) } }) {
        val filtro = f_buscarTrabajador.trim().lowercase()
        employees.filter { e -> filtro.isBlank() || "${e.id} ${e.firstName} ${e.lastName}".lowercase().contains(filtro) }.forEach { e ->
            Label(attrs = { style { display(DisplayStyle.Flex); alignItems(AlignItems.Center); gap(4.px); fontSize(12.px); padding(3.px, 6.px); backgroundColor(if (f_trabajadorIds.contains(e.id)) Color("#dbeafe") else Color("#f8fafc")); borderRadius(4.px); cursor("pointer") } }) {
                Input(InputType.Checkbox) {
                    checked(f_trabajadorIds.contains(e.id))
                    onInput { f_trabajadorIds = if (f_trabajadorIds.contains(e.id)) f_trabajadorIds - e.id else f_trabajadorIds + e.id }
                }
                Text("${e.id} · ${e.firstName} ${e.lastName}".trim())
            }
        }
    }
    Div({ style { display(DisplayStyle.Flex); gap(8.px); marginBottom(16.px); alignItems(AlignItems.Center) } }) {
        Button({ style { padding(8.px, 16.px); backgroundColor(SidebarActiveColor); color(Color.white); property("border", "none"); borderRadius(6.px); cursor("pointer") }; onClick {
            if (f_busy) return@onClick
            if (f_trabajadorIds.isEmpty() || f_tema.isBlank() || f_fecha.isBlank()) { window.alert("Selecciona al menos un trabajador, y captura tema y fecha."); return@onClick }
            f_busy = true
            scope.launch {
                try {
                    for (idSel in f_trabajadorIds) {
                        val trabajadorNombre = employees.firstOrNull { it.id == idSel }?.let { "${it.firstName} ${it.lastName}".trim() } ?: continue
                        client.post("$BACKEND_URL/api/v1/ehs/dc3") {
                            contentType(ContentType.Application.Json)
                            setBody(Dc3Constancia(trabajador = trabajadorNombre, tema = f_tema, fecha = f_fecha, horas = f_horas, responsable = f_responsable, evidenciaUrl = f_evidencia))
                        }
                    }
                    f_trabajadorIds = emptySet(); f_tema = ""; f_fecha = ""; f_horas = ""; f_evidencia = ""; refresh()
                } finally { f_busy = false }
            }
        } }) { Text(if (f_busy) "Guardando..." else "+ Agregar (${f_trabajadorIds.size.coerceAtLeast(1)} constancia${if (f_trabajadorIds.size == 1) "" else "s"})") }
    }
    if (isLoading) { P { Text("Cargando...") } } else {
        Table({ style { width(100.percent) } }) {
            Thead { Tr { Th { Text("Trabajador") }; Th { Text("Tema") }; Th { Text("Fecha") }; Th { Text("Horas") }; Th { Text("Responsable") }; Th { Text("Evidencia") }; Th { Text("") } } }
            Tbody {
                items.forEach { row -> Tr {
                    Td { Text(row.trabajador) }; Td { Text(row.tema) }; Td { Text(row.fecha) }; Td { Text(row.horas) }; Td { Text(row.responsable) }
                    Td { if (row.evidenciaUrl.startsWith("http")) A(href = row.evidenciaUrl, attrs = { target(ATarget.Blank); style { color(Color("#2563eb")); textDecoration("underline") } }) { Text("Ver constancia") } else Text("—") }
                    Td { Button({ style { backgroundColor(Color("#ef4444")); color(Color.white); property("border", "none"); borderRadius(4.px); padding(4.px, 10.px); cursor("pointer") }; onClick { scope.launch { client.delete("$BACKEND_URL/api/v1/ehs/dc3/${row.id}"); refresh() } } }) { Text("X") } }
                } }
                EhsPendingEvidenceRows(evidence, colSpan = 7, moduleType = "dc3", linkTargets = items.map { it.id to "${it.trabajador} · ${it.tema} · ${it.fecha}" }, client = client, scope = scope, onLinked = { refresh() })
            }
        }
    }
}

// EHS-6. Simulacros de Emergencia
@Composable
fun EhsDrillsTab(client: HttpClient, scope: kotlinx.coroutines.CoroutineScope) {
    var items by remember { mutableStateOf(emptyList<EmergencyDrill>()) }
    var evidence by remember { mutableStateOf(emptyList<EhsDocument>()) }
    var isLoading by remember { mutableStateOf(true) }
    var refreshKey by remember { mutableStateOf(0) }
    LaunchedEffect(refreshKey) { isLoading = true; try {
        items = client.get("$BACKEND_URL/api/v1/sap/ehs/simulacros").body()
        evidence = client.get("$BACKEND_URL/api/v1/ehs/documentos?categoria=Simulacro").body()
    } catch (e: Exception) { println("Err: ${e.message}") } finally { isLoading = false } }
    fun refresh() { refreshKey++ }
    var f_fecha by remember { mutableStateOf("") }
    var f_tipo by remember { mutableStateOf("") }
    var f_participantes by remember { mutableStateOf("") }
    var f_tiempoEvacuacion by remember { mutableStateOf("") }
    var f_resultado by remember { mutableStateOf("") }
    var f_observaciones by remember { mutableStateOf("") }
    var f_estado by remember { mutableStateOf("") }
    Span({ style { color(Color.gray); fontSize(13.px); marginBottom(8.px); display(DisplayStyle.Block) } }) { Text("${items.size} registros") }
    Div({ style { display(DisplayStyle.Flex); gap(8.px); marginBottom(16.px); flexWrap(FlexWrap.Wrap); alignItems(AlignItems.Center) } }) {
        Input(InputType.Text) { placeholder("Fecha *"); value(f_fecha); onInput { f_fecha = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(120.px) } }
        Input(InputType.Text) { placeholder("Tipo (Incendio/Sismo/Derrame)"); value(f_tipo); onInput { f_tipo = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(200.px) } }
        Input(InputType.Text) { placeholder("Participantes"); value(f_participantes); onInput { f_participantes = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(120.px) } }
        Input(InputType.Text) { placeholder("Tiempo evacuacion"); value(f_tiempoEvacuacion); onInput { f_tiempoEvacuacion = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(140.px) } }
        Input(InputType.Text) { placeholder("Resultado"); value(f_resultado); onInput { f_resultado = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(160.px) } }
        Input(InputType.Text) { placeholder("Observaciones"); value(f_observaciones); onInput { f_observaciones = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(200.px) } }
        Input(InputType.Text) { placeholder("Estado"); value(f_estado); onInput { f_estado = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(100.px) } }
        Button({ style { padding(8.px, 16.px); backgroundColor(SidebarActiveColor); color(Color.white); property("border", "none"); borderRadius(6.px); cursor("pointer") }; onClick { if (f_fecha.isNotBlank()) { scope.launch { client.post("$BACKEND_URL/api/v1/sap/ehs/simulacros") { contentType(ContentType.Application.Json); setBody(EmergencyDrill(fecha = f_fecha, tipo = f_tipo, participantes = f_participantes, tiempoEvacuacion = f_tiempoEvacuacion, resultado = f_resultado, observaciones = f_observaciones, estado = f_estado)) }; f_fecha = ""; f_tipo = ""; f_participantes = ""; f_tiempoEvacuacion = ""; f_resultado = ""; f_observaciones = ""; f_estado = ""; refresh() } } else { window.alert("La fecha es obligatoria.") } } }) { Text("+ Agregar") }
    }
    if (isLoading) { P { Text("Cargando...") } } else {
        Table({ style { width(100.percent) } }) {
            Thead { Tr { Th { Text("Fecha") }; Th { Text("Tipo") }; Th { Text("Particip.") }; Th { Text("T.Evacuac.") }; Th { Text("Resultado") }; Th { Text("Observaciones") }; Th { Text("Estado") }; Th { Text("Evidencias") }; Th { Text("") } } }
            Tbody {
                items.forEach { row -> Tr { Td { Text(row.fecha) }; Td { Text(row.tipo) }; Td { Text(row.participantes) }; Td { Text(row.tiempoEvacuacion) }; Td { Text(row.resultado) }; Td { Text(row.observaciones) }; Td { Text(row.estado) }; Td { EhsEvidenceButtons(evidence.filter { it.moduleRecordId == row.id }) }; Td { Button({ style { backgroundColor(Color("#ef4444")); color(Color.white); property("border", "none"); borderRadius(4.px); padding(4.px, 10.px); cursor("pointer") }; onClick { scope.launch { client.delete("$BACKEND_URL/api/v1/sap/ehs/simulacros/${row.id}"); refresh() } } }) { Text("X") } } } }
                EhsPendingEvidenceRows(evidence, colSpan = 9, moduleType = "drill", linkTargets = items.map { it.id to "${it.tipo} · ${it.fecha}" }, client = client, scope = scope, onLinked = { refresh() })
            }
        }
    }
}

// EHS-7. Matriz de Riesgos / IPER
@Composable
fun EhsRiskMatrixTab(client: HttpClient, scope: kotlinx.coroutines.CoroutineScope) {
    var items by remember { mutableStateOf(emptyList<RiskMatrix>()) }
    var evidence by remember { mutableStateOf(emptyList<EhsDocument>()) }
    var isLoading by remember { mutableStateOf(true) }
    var refreshKey by remember { mutableStateOf(0) }
    LaunchedEffect(refreshKey) { isLoading = true; try {
        items = client.get("$BACKEND_URL/api/v1/sap/ehs/matriz-riesgos").body()
        evidence = client.get("$BACKEND_URL/api/v1/ehs/documentos?categoria=Riesgos").body()
    } catch (e: Exception) { println("Err: ${e.message}") } finally { isLoading = false } }
    fun refresh() { refreshKey++ }
    var f_area by remember { mutableStateOf("") }
    var f_proceso by remember { mutableStateOf("") }
    var f_riesgoIdentificado by remember { mutableStateOf("") }
    var f_probabilidad by remember { mutableStateOf("") }
    var f_severidad by remember { mutableStateOf("") }
    var f_nivelRiesgo by remember { mutableStateOf("") }
    var f_controles by remember { mutableStateOf("") }
    var f_responsable by remember { mutableStateOf("") }
    var f_estado by remember { mutableStateOf("") }
    Span({ style { color(Color.gray); fontSize(13.px); marginBottom(8.px); display(DisplayStyle.Block) } }) { Text("${items.size} registros") }
    Div({ style { display(DisplayStyle.Flex); gap(8.px); marginBottom(16.px); flexWrap(FlexWrap.Wrap); alignItems(AlignItems.Center) } }) {
        Input(InputType.Text) { placeholder("Area *"); value(f_area); onInput { f_area = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(140.px) } }
        Input(InputType.Text) { placeholder("Proceso"); value(f_proceso); onInput { f_proceso = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(140.px) } }
        Input(InputType.Text) { placeholder("Riesgo identificado"); value(f_riesgoIdentificado); onInput { f_riesgoIdentificado = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(200.px) } }
        Input(InputType.Text) { placeholder("Probabilidad (B/M/A)"); value(f_probabilidad); onInput { f_probabilidad = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(160.px) } }
        Input(InputType.Text) { placeholder("Severidad (B/M/A)"); value(f_severidad); onInput { f_severidad = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(160.px) } }
        Input(InputType.Text) { placeholder("Nivel riesgo"); value(f_nivelRiesgo); onInput { f_nivelRiesgo = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(120.px) } }
        Input(InputType.Text) { placeholder("Controles"); value(f_controles); onInput { f_controles = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(200.px) } }
        Input(InputType.Text) { placeholder("Responsable"); value(f_responsable); onInput { f_responsable = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(150.px) } }
        Input(InputType.Text) { placeholder("Estado"); value(f_estado); onInput { f_estado = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(100.px) } }
        Button({ style { padding(8.px, 16.px); backgroundColor(SidebarActiveColor); color(Color.white); property("border", "none"); borderRadius(6.px); cursor("pointer") }; onClick { if (f_area.isNotBlank()) { scope.launch { client.post("$BACKEND_URL/api/v1/sap/ehs/matriz-riesgos") { contentType(ContentType.Application.Json); setBody(RiskMatrix(area = f_area, proceso = f_proceso, riesgoIdentificado = f_riesgoIdentificado, probabilidad = f_probabilidad, severidad = f_severidad, nivelRiesgo = f_nivelRiesgo, controles = f_controles, responsable = f_responsable, estado = f_estado)) }; f_area = ""; f_proceso = ""; f_riesgoIdentificado = ""; f_probabilidad = ""; f_severidad = ""; f_nivelRiesgo = ""; f_controles = ""; f_responsable = ""; f_estado = ""; refresh() } } else { window.alert("El area es obligatoria.") } } }) { Text("+ Agregar") }
    }
    if (isLoading) { P { Text("Cargando...") } } else {
        Table({ style { width(100.percent) } }) {
            Thead { Tr { Th { Text("Area") }; Th { Text("Proceso") }; Th { Text("Riesgo") }; Th { Text("Prob.") }; Th { Text("Sev.") }; Th { Text("Nivel") }; Th { Text("Controles") }; Th { Text("Responsable") }; Th { Text("Estado") }; Th { Text("Evidencias") }; Th { Text("") } } }
            Tbody {
                items.forEach { row -> Tr { Td { Text(row.area) }; Td { Text(row.proceso) }; Td { Text(row.riesgoIdentificado) }; Td { Text(row.probabilidad) }; Td { Text(row.severidad) }; Td { Text(row.nivelRiesgo) }; Td { Text(row.controles) }; Td { Text(row.responsable) }; Td { Text(row.estado) }; Td { EhsEvidenceButtons(evidence.filter { it.moduleRecordId == row.id }) }; Td { Button({ style { backgroundColor(Color("#ef4444")); color(Color.white); property("border", "none"); borderRadius(4.px); padding(4.px, 10.px); cursor("pointer") }; onClick { scope.launch { client.delete("$BACKEND_URL/api/v1/sap/ehs/matriz-riesgos/${row.id}"); refresh() } } }) { Text("X") } } } }
                EhsPendingEvidenceRows(evidence, colSpan = 11, moduleType = "risk", linkTargets = items.map { it.id to "${it.area} · ${it.riesgoIdentificado}" }, client = client, scope = scope, onLinked = { refresh() })
            }
        }
    }
}

@Composable
fun GrcSecurityModule(client: HttpClient, scope: kotlinx.coroutines.CoroutineScope, t: Translations) {
    var items by remember { mutableStateOf(emptyList<AccessAuditLog>()) }
    var isLoading by remember { mutableStateOf(true) }
    var refreshKey by remember { mutableStateOf(0) }

    LaunchedEffect(refreshKey) {
        isLoading = true
        try {
            items = client.get("$BACKEND_URL/api/v1/sap/grc/auditoria-accesos").body()
        } catch (e: Exception) {
            println("Error cargando GrcSecurityModule: ${e.message}")
        } finally {
            isLoading = false
        }
    }
    fun refresh() { refreshKey++ }

    var f_fecha by remember { mutableStateOf("") }
    var f_usuario by remember { mutableStateOf("") }
    var f_accion by remember { mutableStateOf("") }
    var f_modulo by remember { mutableStateOf("") }
    var f_resultado by remember { mutableStateOf("") }

    Div({ style { backgroundColor(Color.white); padding(32.px); borderRadius(12.px); property("box-shadow", CardShadow) } }) {
        Div({ style { display(DisplayStyle.Flex); justifyContent(JustifyContent.SpaceBetween); alignItems(AlignItems.Center); marginBottom(16.px) } }) {
            H3({ style { margin(0.px) } }) { Text("SAP Security / GRC · Gobierno, Riesgo y Cumplimiento") }
            Span({ style { color(Color.gray); fontSize(13.px) } }) { Text("${items.size} registros") }
        }

        Div({ style { display(DisplayStyle.Flex); gap(8.px); marginBottom(16.px); flexWrap(FlexWrap.Wrap); alignItems(AlignItems.Center) } }) {
            Input(InputType.Text) { placeholder("Fecha *"); value(f_fecha); onInput { f_fecha = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(130.px) } }
            Input(InputType.Text) { placeholder("Usuario *"); value(f_usuario); onInput { f_usuario = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(180.px) } }
            Input(InputType.Text) { placeholder("Accion realizada"); value(f_accion); onInput { f_accion = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(220.px) } }
            Input(InputType.Text) { placeholder("Modulo"); value(f_modulo); onInput { f_modulo = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(140.px) } }
            Input(InputType.Text) { placeholder("Resultado (Permitido/Denegado)"); value(f_resultado); onInput { f_resultado = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(200.px) } }
            Button({
                style { padding(8.px, 16.px); backgroundColor(SidebarActiveColor); color(Color.white); property("border", "none"); borderRadius(6.px); cursor("pointer") }
                onClick {
                    if (f_fecha.isNotBlank()) {
                        scope.launch {
                            client.post("$BACKEND_URL/api/v1/sap/grc/auditoria-accesos") {
                                contentType(ContentType.Application.Json)
                                setBody(AccessAuditLog(fecha = f_fecha, usuario = f_usuario, accion = f_accion, modulo = f_modulo, resultado = f_resultado))
                            }
                            f_fecha = ""
                            f_usuario = ""
                            f_accion = ""
                            f_modulo = ""
                            f_resultado = ""
                            refresh()
                        }
                    } else {
                        window.alert("Completa el campo obligatorio para agregar el registro.")
                    }
                }
            }) { Text("+ Agregar") }
        }

        if (isLoading) {
            P { Text("Cargando...") }
        } else {
            Table({ style { width(100.percent) } }) {
                Thead { Tr { Th { Text("Fecha") }; Th { Text("Usuario") }; Th { Text("Accion") }; Th { Text("Modulo") }; Th { Text("Resultado") }; Th { Text("") } } }
                Tbody {
                    items.forEach { row ->
                        Tr {
                            Td { Text(row.fecha) }; Td { Text(row.usuario) }; Td { Text(row.accion) }; Td { Text(row.modulo) }; Td { Text(row.resultado) }
                            Td {
                                Button({
                                    style { backgroundColor(Color("#ef4444")); color(Color.white); property("border", "none"); borderRadius(4.px); padding(4.px, 10.px); cursor("pointer") }
                                    onClick { scope.launch { client.delete("$BACKEND_URL/api/v1/sap/grc/auditoria-accesos/${row.id}"); refresh() } }
                                }) { Text("Eliminar") }
                            }
                        }
                    }
                }
            }
        }
    }
}

// Modulos estilo SAP: FI (Contabilidad Financiera), PM (Mantenimiento de Planta), HCM (Reclutamiento)
// Mismo patron que SapModulesUi.kt: HttpClient + LaunchedEffect + formulario inline + tabla + delete

@Composable
fun FinancialAccountingModule(client: HttpClient, scope: kotlinx.coroutines.CoroutineScope, t: Translations) {
    var items by remember { mutableStateOf(emptyList<JournalEntry>()) }
    var isLoading by remember { mutableStateOf(true) }
    var refreshKey by remember { mutableStateOf(0) }

    LaunchedEffect(refreshKey) {
        isLoading = true
        try {
            items = client.get("$BACKEND_URL/api/v1/sap/fi/asientos").body()
        } catch (e: Exception) {
            println("Error cargando FinancialAccountingModule: ${e.message}")
        } finally {
            isLoading = false
        }
    }
    fun refresh() { refreshKey++ }

    var f_fecha by remember { mutableStateOf("") }
    var f_cuenta by remember { mutableStateOf("") }
    var f_concepto by remember { mutableStateOf("") }
    var f_tipo by remember { mutableStateOf("") }
    var f_monto by remember { mutableStateOf("") }
    var f_referencia by remember { mutableStateOf("") }

    Div({ style { backgroundColor(Color.white); padding(32.px); borderRadius(12.px); property("box-shadow", CardShadow) } }) {
        Div({ style { display(DisplayStyle.Flex); justifyContent(JustifyContent.SpaceBetween); alignItems(AlignItems.Center); marginBottom(16.px) } }) {
            H3({ style { margin(0.px) } }) { Text("FI · Contabilidad Financiera (Financial Accounting)") }
            Span({ style { color(Color.gray); fontSize(13.px) } }) { Text("${items.size} registros") }
        }

        Div({ style { display(DisplayStyle.Flex); gap(8.px); marginBottom(16.px); flexWrap(FlexWrap.Wrap); alignItems(AlignItems.Center) } }) {
            Input(InputType.Text) { placeholder("Fecha *"); value(f_fecha); onInput { f_fecha = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(130.px) } }
            Input(InputType.Text) { placeholder("Cuenta contable *"); value(f_cuenta); onInput { f_cuenta = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(180.px) } }
            Input(InputType.Text) { placeholder("Concepto"); value(f_concepto); onInput { f_concepto = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(220.px) } }
            Input(InputType.Text) { placeholder("Tipo (Cargo/Abono)"); value(f_tipo); onInput { f_tipo = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(150.px) } }
            Input(InputType.Text) { placeholder("Monto"); value(f_monto); onInput { f_monto = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(130.px) } }
            Input(InputType.Text) { placeholder("Referencia"); value(f_referencia); onInput { f_referencia = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(160.px) } }
            Button({
                style { padding(8.px, 16.px); backgroundColor(SidebarActiveColor); color(Color.white); property("border", "none"); borderRadius(6.px); cursor("pointer") }
                onClick {
                    if (f_fecha.isNotBlank()) {
                        scope.launch {
                            client.post("$BACKEND_URL/api/v1/sap/fi/asientos") {
                                contentType(ContentType.Application.Json)
                                setBody(JournalEntry(fecha = f_fecha, cuenta = f_cuenta, concepto = f_concepto, tipo = f_tipo, monto = f_monto, referencia = f_referencia))
                            }
                            f_fecha = ""
                            f_cuenta = ""
                            f_concepto = ""
                            f_tipo = ""
                            f_monto = ""
                            f_referencia = ""
                            refresh()
                        }
                    } else {
                        window.alert("Completa el campo obligatorio para agregar el registro.")
                    }
                }
            }) { Text("+ Agregar") }
        }

        if (isLoading) {
            P { Text("Cargando...") }
        } else {
            Table({ style { width(100.percent) } }) {
                Thead { Tr { Th { Text("Fecha") }; Th { Text("Cuenta") }; Th { Text("Concepto") }; Th { Text("Tipo") }; Th { Text("Monto") }; Th { Text("Referencia") }; Th { Text("") } } }
                Tbody {
                    items.forEach { row ->
                        Tr {
                            Td { Text(row.fecha) }; Td { Text(row.cuenta) }; Td { Text(row.concepto) }; Td { Text(row.tipo) }; Td { Text(row.monto) }; Td { Text(row.referencia) }
                            Td {
                                Button({
                                    style { backgroundColor(Color("#ef4444")); color(Color.white); property("border", "none"); borderRadius(4.px); padding(4.px, 10.px); cursor("pointer") }
                                    onClick { scope.launch { client.delete("$BACKEND_URL/api/v1/sap/fi/asientos/${row.id}"); refresh() } }
                                }) { Text("Eliminar") }
                            }
                        }
                    }
                }
            }
        }
    }
}

@Composable
fun PlantMaintenanceModule(client: HttpClient, scope: kotlinx.coroutines.CoroutineScope, t: Translations) {
    var items by remember { mutableStateOf(emptyList<MaintenanceOrder>()) }
    var isLoading by remember { mutableStateOf(true) }
    var refreshKey by remember { mutableStateOf(0) }

    LaunchedEffect(refreshKey) {
        isLoading = true
        try {
            items = client.get("$BACKEND_URL/api/v1/sap/pm/ordenes-mantenimiento").body()
        } catch (e: Exception) {
            println("Error cargando PlantMaintenanceModule: ${e.message}")
        } finally {
            isLoading = false
        }
    }
    fun refresh() { refreshKey++ }

    var f_equipo by remember { mutableStateOf("") }
    var f_tipo by remember { mutableStateOf("") }
    var f_fechaProgramada by remember { mutableStateOf("") }
    var f_fechaRealizada by remember { mutableStateOf("") }
    var f_tecnico by remember { mutableStateOf("") }
    var f_estado by remember { mutableStateOf("") }
    var f_notas by remember { mutableStateOf("") }

    Div({ style { backgroundColor(Color.white); padding(32.px); borderRadius(12.px); property("box-shadow", CardShadow) } }) {
        Div({ style { display(DisplayStyle.Flex); justifyContent(JustifyContent.SpaceBetween); alignItems(AlignItems.Center); marginBottom(16.px) } }) {
            H3({ style { margin(0.px) } }) { Text("PM · Mantenimiento de Planta (Plant Maintenance)") }
            Span({ style { color(Color.gray); fontSize(13.px) } }) { Text("${items.size} registros") }
        }

        Div({ style { display(DisplayStyle.Flex); gap(8.px); marginBottom(16.px); flexWrap(FlexWrap.Wrap); alignItems(AlignItems.Center) } }) {
            Input(InputType.Text) { placeholder("Equipo *"); value(f_equipo); onInput { f_equipo = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(180.px) } }
            Input(InputType.Text) { placeholder("Tipo (Preventivo/Correctivo)"); value(f_tipo); onInput { f_tipo = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(200.px) } }
            Input(InputType.Text) { placeholder("Fecha programada"); value(f_fechaProgramada); onInput { f_fechaProgramada = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(140.px) } }
            Input(InputType.Text) { placeholder("Fecha realizada"); value(f_fechaRealizada); onInput { f_fechaRealizada = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(140.px) } }
            Input(InputType.Text) { placeholder("Tecnico"); value(f_tecnico); onInput { f_tecnico = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(160.px) } }
            Input(InputType.Text) { placeholder("Estado"); value(f_estado); onInput { f_estado = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(120.px) } }
            Input(InputType.Text) { placeholder("Notas"); value(f_notas); onInput { f_notas = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(220.px) } }
            Button({
                style { padding(8.px, 16.px); backgroundColor(SidebarActiveColor); color(Color.white); property("border", "none"); borderRadius(6.px); cursor("pointer") }
                onClick {
                    if (f_equipo.isNotBlank()) {
                        scope.launch {
                            client.post("$BACKEND_URL/api/v1/sap/pm/ordenes-mantenimiento") {
                                contentType(ContentType.Application.Json)
                                setBody(MaintenanceOrder(equipo = f_equipo, tipo = f_tipo, fechaProgramada = f_fechaProgramada, fechaRealizada = f_fechaRealizada, tecnico = f_tecnico, estado = f_estado, notas = f_notas))
                            }
                            f_equipo = ""
                            f_tipo = ""
                            f_fechaProgramada = ""
                            f_fechaRealizada = ""
                            f_tecnico = ""
                            f_estado = ""
                            f_notas = ""
                            refresh()
                        }
                    } else {
                        window.alert("Completa el campo obligatorio para agregar el registro.")
                    }
                }
            }) { Text("+ Agregar") }
        }

        if (isLoading) {
            P { Text("Cargando...") }
        } else {
            Table({ style { width(100.percent) } }) {
                Thead { Tr { Th { Text("Equipo") }; Th { Text("Tipo") }; Th { Text("F. Programada") }; Th { Text("F. Realizada") }; Th { Text("Tecnico") }; Th { Text("Estado") }; Th { Text("Notas") }; Th { Text("") } } }
                Tbody {
                    items.forEach { row ->
                        Tr {
                            Td { Text(row.equipo) }; Td { Text(row.tipo) }; Td { Text(row.fechaProgramada) }; Td { Text(row.fechaRealizada) }; Td { Text(row.tecnico) }; Td { Text(row.estado) }; Td { Text(row.notas) }
                            Td {
                                Button({
                                    style { backgroundColor(Color("#ef4444")); color(Color.white); property("border", "none"); borderRadius(4.px); padding(4.px, 10.px); cursor("pointer") }
                                    onClick { scope.launch { client.delete("$BACKEND_URL/api/v1/sap/pm/ordenes-mantenimiento/${row.id}"); refresh() } }
                                }) { Text("Eliminar") }
                            }
                        }
                    }
                }
            }
        }
    }
}

@Composable
fun RecruitmentSapModule(client: HttpClient, scope: kotlinx.coroutines.CoroutineScope, t: Translations) {
    var items by remember { mutableStateOf(emptyList<RecruitmentVacancy>()) }
    var isLoading by remember { mutableStateOf(true) }
    var refreshKey by remember { mutableStateOf(0) }

    LaunchedEffect(refreshKey) {
        isLoading = true
        try {
            items = client.get("$BACKEND_URL/api/v1/sap/hcm/vacantes").body()
        } catch (e: Exception) {
            println("Error cargando RecruitmentSapModule: ${e.message}")
        } finally {
            isLoading = false
        }
    }
    fun refresh() { refreshKey++ }

    var f_puesto by remember { mutableStateOf("") }
    var f_departamento by remember { mutableStateOf("") }
    var f_fechaApertura by remember { mutableStateOf("") }
    var f_vacantes by remember { mutableStateOf("") }
    var f_candidatosPostulados by remember { mutableStateOf("") }
    var f_estado by remember { mutableStateOf("") }

    Div({ style { backgroundColor(Color.white); padding(32.px); borderRadius(12.px); property("box-shadow", CardShadow) } }) {
        Div({ style { display(DisplayStyle.Flex); justifyContent(JustifyContent.SpaceBetween); alignItems(AlignItems.Center); marginBottom(16.px) } }) {
            H3({ style { margin(0.px) } }) { Text("HCM · Reclutamiento (Human Capital Management)") }
            Span({ style { color(Color.gray); fontSize(13.px) } }) { Text("${items.size} registros") }
        }

        Div({ style { display(DisplayStyle.Flex); gap(8.px); marginBottom(16.px); flexWrap(FlexWrap.Wrap); alignItems(AlignItems.Center) } }) {
            Input(InputType.Text) { placeholder("Puesto *"); value(f_puesto); onInput { f_puesto = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(180.px) } }
            Input(InputType.Text) { placeholder("Departamento"); value(f_departamento); onInput { f_departamento = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(160.px) } }
            Input(InputType.Text) { placeholder("Fecha apertura"); value(f_fechaApertura); onInput { f_fechaApertura = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(130.px) } }
            Input(InputType.Text) { placeholder("No. vacantes"); value(f_vacantes); onInput { f_vacantes = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(110.px) } }
            Input(InputType.Text) { placeholder("Candidatos postulados"); value(f_candidatosPostulados); onInput { f_candidatosPostulados = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(160.px) } }
            Input(InputType.Text) { placeholder("Estado"); value(f_estado); onInput { f_estado = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(120.px) } }
            Button({
                style { padding(8.px, 16.px); backgroundColor(SidebarActiveColor); color(Color.white); property("border", "none"); borderRadius(6.px); cursor("pointer") }
                onClick {
                    if (f_puesto.isNotBlank()) {
                        scope.launch {
                            client.post("$BACKEND_URL/api/v1/sap/hcm/vacantes") {
                                contentType(ContentType.Application.Json)
                                setBody(RecruitmentVacancy(puesto = f_puesto, departamento = f_departamento, fechaApertura = f_fechaApertura, vacantes = f_vacantes, candidatosPostulados = f_candidatosPostulados, estado = f_estado))
                            }
                            f_puesto = ""
                            f_departamento = ""
                            f_fechaApertura = ""
                            f_vacantes = ""
                            f_candidatosPostulados = ""
                            f_estado = ""
                            refresh()
                        }
                    } else {
                        window.alert("Completa el campo obligatorio para agregar el registro.")
                    }
                }
            }) { Text("+ Agregar") }
        }

        if (isLoading) {
            P { Text("Cargando...") }
        } else {
            Table({ style { width(100.percent) } }) {
                Thead { Tr { Th { Text("Puesto") }; Th { Text("Departamento") }; Th { Text("Fecha Apertura") }; Th { Text("Vacantes") }; Th { Text("Candidatos") }; Th { Text("Estado") }; Th { Text("") } } }
                Tbody {
                    items.forEach { row ->
                        Tr {
                            Td { Text(row.puesto) }; Td { Text(row.departamento) }; Td { Text(row.fechaApertura) }; Td { Text(row.vacantes) }; Td { Text(row.candidatosPostulados) }; Td { Text(row.estado) }
                            Td {
                                Button({
                                    style { backgroundColor(Color("#ef4444")); color(Color.white); property("border", "none"); borderRadius(4.px); padding(4.px, 10.px); cursor("pointer") }
                                    onClick { scope.launch { client.delete("$BACKEND_URL/api/v1/sap/hcm/vacantes/${row.id}"); refresh() } }
                                }) { Text("Eliminar") }
                            }
                        }
                    }
                }
            }
        }
    }
}

// Una evidencia clasificada aparece en su seccion aun sin existir un registro
// operativo. No inventamos inspecciones ni asociamos IDs a partir del nombre.
@Composable
fun EhsCategoryEvidence(client: HttpClient, categoria: String) {
    var documents by remember(categoria) { mutableStateOf(emptyList<EhsDocument>()) }
    var error by remember(categoria) { mutableStateOf("") }
    LaunchedEffect(categoria) {
        try {
            documents = client.get("$BACKEND_URL/api/v1/ehs/documentos?categoria=$categoria").body()
            error = ""
        } catch (e: Exception) {
            error = "No se pudieron cargar las evidencias: ${e.message ?: "error"}"
        }
    }
    Div({ style { padding(12.px); marginBottom(16.px); backgroundColor(Color.white); borderRadius(8.px); property("border", "1px solid #e2e8f0") } }) {
        H4({ style { margin(0.px, 0.px, 8.px, 0.px) } }) { Text("Evidencias de $categoria (${documents.size})") }
        if (error.isNotBlank()) P { Text(error) }
        else if (documents.isEmpty()) P { Text("No hay evidencias de esta categoría.") }
        else Div({ style { maxHeight(300.px); overflow("auto") } }) {
            documents.forEach { doc ->
                Div({ style { marginBottom(5.px) } }) {
                    Span { Text("#${doc.id} · ${doc.titulo} · ") }
                    EhsEvidenceButtons(listOf(doc))
                    if (doc.moduleRecordId > 0) Span { Text(" · registro #${doc.moduleRecordId}") }
                }
            }
        }
    }
}

// Fila de aviso para evidencia ya clasificada pero aun sin un registro
// estructurado que la reclame (moduleRecordId == 0). Antes estos documentos
// se listaban todos juntos arriba del modulo; ahora aparecen dentro de la
// misma tabla, ocupando el ancho completo, hasta que se les cree su registro.
// Convierte dd/MM/yyyy <-> yyyy-MM/dd para el calendario nativo del navegador
// (input type=date). El resto del sistema sigue guardando dd/MM/yyyy.
private fun ddmmyyyyToIso(s: String): String {
    val p = s.split("/")
    return if (p.size == 3) "${p[2]}-${p[1].padStart(2, '0')}-${p[0].padStart(2, '0')}" else ""
}
private fun isoToDdmmyyyy(s: String): String {
    val p = s.split("-")
    return if (p.size == 3) "${p[2]}/${p[1]}/${p[0]}" else ""
}

// Campo de fecha con calendario desplegable en vez de captura libre de texto.
@Composable
fun FechaInput(fecha: String, onFechaChange: (String) -> Unit, width: Int = 140, placeholder: String = "Fecha") {
    Input(InputType.Date) {
        placeholder(placeholder)
        value(ddmmyyyyToIso(fecha))
        onInput { onFechaChange(isoToDdmmyyyy(it.value)) }
        style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(width.px) }
    }
}

@Composable
fun EhsPendingEvidenceRows(
    evidence: List<EhsDocument>,
    colSpan: Int,
    moduleType: String,
    // Pares (id real del registro, etiqueta legible) de las filas ya visibles
    // en esta misma tabla, para elegir por nombre/fecha en vez de adivinar un
    // ID interno que la interfaz nunca muestra.
    linkTargets: List<Pair<Int, String>>,
    client: HttpClient,
    scope: kotlinx.coroutines.CoroutineScope,
    onLinked: () -> Unit
) {
    evidence.filter { it.moduleRecordId == 0 }.forEach { doc ->
        var selectedId by remember(doc.id) { mutableStateOf(0) }
        var linkMsg by remember(doc.id) { mutableStateOf("") }
        Tr({ style { backgroundColor(Color("#fffbeb")) } }) {
            Td({
                attr("colspan", colSpan.toString())
                style { padding(8.px, 12.px); property("border-bottom", "1px solid #f1f5f9"); fontSize(13.px) }
            }) {
                Span({ style { color(Color("#92400e")); marginRight(8.px) } }) { Text("Evidencia sin registro vinculado ·") }
                Span({ style { fontWeight("600"); marginRight(8.px) } }) { Text(doc.titulo) }
                EhsEvidenceButtons(listOf(doc))
                if (linkTargets.isEmpty()) {
                    Span({ style { marginLeft(10.px); color(Color.gray); fontSize(12.px) } }) { Text("Crea primero el registro para poder vincularla.") }
                } else {
                    Span({ style { marginLeft(10.px); color(Color.gray); fontSize(12.px) } }) { Text("Vincular con:") }
                    Select({
                        style { marginLeft(4.px); padding(3.px); borderRadius(4.px); property("border", "1px solid #cbd5e1"); fontSize(12.px) }
                        onChange { selectedId = it.value?.toIntOrNull() ?: 0; linkMsg = "" }
                    }) {
                        Option("0") { Text("Selecciona un registro...") }
                        linkTargets.forEach { (id, label) -> Option(id.toString()) { Text(label) } }
                    }
                    Button({
                        style { marginLeft(4.px); padding(3.px, 8.px); backgroundColor(Color("#059669")); color(Color.white); property("border", "none"); borderRadius(4.px); cursor("pointer"); fontSize(11.px) }
                        onClick {
                            if (selectedId <= 0) {
                                linkMsg = "Elige un registro"
                            } else {
                                scope.launch {
                                    try {
                                        val resp = client.post("$BACKEND_URL/api/v1/ehs/documentos/${doc.id}/vincular") {
                                            contentType(ContentType.Application.Json)
                                            setBody(EhsDocumentLinkRequest(moduleType = moduleType, moduleRecordId = selectedId))
                                        }
                                        if (resp.status.value in 200..299) onLinked()
                                        else linkMsg = "No se pudo vincular ese registro"
                                    } catch (e: Exception) { linkMsg = "Error: ${e.message}" }
                                }
                            }
                        }
                    }) { Text("Vincular") }
                }
                if (linkMsg.isNotBlank()) Span({ style { marginLeft(8.px); color(Color("#dc2626")); fontSize(11.px) } }) { Text(linkMsg) }
            }
        }
    }
}

// Abre una evidencia usando el token de la sesión. window.open(url) no sirve
// porque una pestaña nueva no envía el header Authorization.
@Composable
fun EhsEvidenceButtons(documents: List<EhsDocument>) {
    if (documents.isEmpty()) {
        Span({ style { color(Color("#94a3b8")); fontSize(12.px) } }) { Text("Sin evidencia") }
        return
    }
    Div({ style { display(DisplayStyle.Flex); gap(4.px); flexWrap(FlexWrap.Wrap) } }) {
        documents.forEach { doc ->
            Button({
                style { padding(4.px, 8.px); backgroundColor(Color("#2563eb")); color(Color.white); property("border", "none"); borderRadius(5.px); cursor("pointer"); fontSize(11.px) }
                onClick {
                    val url = "$BACKEND_URL/api/v1/ehs/documentos/${doc.id}/descargar"
                    val options = js("({})")
                    options.method = "GET"
                    options.headers = js("({})")
                    options.headers.Authorization = "Bearer $apiAuthToken"
                    window.asDynamic().fetch(url, options)
                        .then { response: dynamic ->
                            if (!response.ok) throw Exception("HTTP " + response.status)
                            response.blob()
                        }
                        .then { blob: dynamic ->
                            val blobUrl = window.asDynamic().URL.createObjectURL(blob)
                            window.open(blobUrl as String, "_blank")
                            window.setTimeout({ window.asDynamic().URL.revokeObjectURL(blobUrl) }, 60000)
                        }
                        .`catch` { err: dynamic -> window.alert("No se pudo abrir ${doc.fileName}: " + (err.message ?: "error de descarga")) }
                }
            }) { Text(doc.fileName.ifBlank { doc.titulo }) }
        }
    }
}

// El navegador envia el File directamente como multipart, sin convertirlo a base64.
suspend fun uploadEvidenceFile(file: org.w3c.files.File, fields: Map<String, String>): String =
    suspendCoroutine { continuation ->
        val form = js("new FormData()")
        fields.forEach { (key, value) -> form.append(key, value) }
        form.append("file", file, file.name)
        val options = js("({})")
        options.method = "POST"
        options.headers = js("({})")
        options.headers.Authorization = "Bearer $apiAuthToken"
        options.body = form
        window.asDynamic().fetch("$BACKEND_URL/api/v1/ehs/documentos/subir-archivo", options).then(
            { response: dynamic ->
                response.json().then(
                    { result: dynamic ->
                        if (response.ok && result.status == "ok" && result.id != null) {
                            continuation.resume(result.id.toString())
                        } else {
                            continuation.resumeWithException(IllegalStateException(
                                result.message?.toString() ?: "HTTP ${response.status}"))
                        }
                    },
                    { _: dynamic -> continuation.resumeWithException(IllegalStateException("Respuesta ilegible del servidor")) }
                )
            },
            { _: dynamic -> continuation.resumeWithException(IllegalStateException("Error de red al subir")) }
        )
    }

// Vista previa transversal: el archivo se analiza, no se almacena ni crea registros.
private suspend fun analyzeOperationalFile(file: org.w3c.files.File, category: String): OperationalDocumentReadResult =
    suspendCoroutine { continuation ->
        val form = js("new FormData()")
        form.append("categoria", category)
        form.append("file", file, file.name)
        val options = js("({})")
        options.method = "POST"
        options.headers = js("({})")
        options.headers.Authorization = "Bearer $apiAuthToken"
        options.body = form
        window.asDynamic().fetch("$BACKEND_URL/api/v1/ehs/documentos/extraer", options).then(
            { response: dynamic ->
                response.text().then(
                    { body: dynamic ->
                        try {
                            if (!response.ok) throw IllegalStateException("HTTP ${response.status}: $body")
                            continuation.resume(Json.decodeFromString<OperationalDocumentReadResult>(body as String))
                        } catch (e: Exception) { continuation.resumeWithException(e) }
                    },
                    { _: dynamic -> continuation.resumeWithException(IllegalStateException("Respuesta ilegible")) }
                )
            },
            { _: dynamic -> continuation.resumeWithException(IllegalStateException("No se pudo subir para análisis")) }
        )
    }

private val operationalRoutes = mapOf(
    "Inspeccion" to "inspecciones", "Incidente" to "incidentes", "PermisoTrabajo" to "permisos-trabajo",
    "EPP" to "entregas-epp", "Capacitacion" to "capacitaciones", "Simulacro" to "simulacros",
    "Riesgos" to "matriz-riesgos", "Residuos" to "residuos", "Quimicos" to "quimicos",
    "ExamenMedico" to "salud"
)
private val requiredOperationalFields = mapOf(
    "Inspeccion" to listOf("fecha"), "Incidente" to listOf("fecha"),
    "EPP" to listOf("fecha"), "Capacitacion" to listOf("fecha"), "Simulacro" to listOf("fecha"),
    "Residuos" to listOf("fecha", "residuo"), "Quimicos" to listOf("nombre"),
    "ExamenMedico" to listOf("empleadoId", "fecha")
)

// Un año solo se deduce de una carpeta llamada exactamente AAAA, no del
// nombre de una NOM (p. ej. NOM-035-2018 no demuestra el año del documento).
private fun evidenceYear(file: org.w3c.files.File, fallback: String): Int? {
    val path = (file.asDynamic().webkitRelativePath as? String).orEmpty()
    val folderYears = path.split('/').dropLast(1).filter { it.matches(Regex("(19|20)\\d{2}")) }.distinct()
    return if (folderYears.size == 1) folderYears[0].toInt()
        else if (fallback == "General") -1
        else fallback.toIntOrNull()?.takeIf { it in 1900..2100 }
}

// EHS-15. Auditorías con checklist y hallazgos vinculados a planes de acción
@Composable
fun EhsChecklistsTab(client: HttpClient, scope: kotlinx.coroutines.CoroutineScope) {
    var lists by remember { mutableStateOf(emptyList<EhsChecklist>()) }
    var selectedId by remember { mutableStateOf(0) }
    var items by remember { mutableStateOf(emptyList<EhsChecklistItem>()) }
    var isLoading by remember { mutableStateOf(true) }
    var notice by remember { mutableStateOf("") }
    var error by remember { mutableStateOf("") }
    var refreshKey by remember { mutableStateOf(0) }
    LaunchedEffect(refreshKey) { isLoading = true; try {
        lists = client.get("$BACKEND_URL/api/v1/ehs/checklists").body()
        items = if (selectedId > 0) client.get("$BACKEND_URL/api/v1/ehs/checklists/$selectedId/items").body() else emptyList()
    } catch (e: Exception) { error = e.message ?: "Error cargando auditorías" } finally { isLoading = false } }
    fun refresh(keepSelection: Boolean = true) { if (!keepSelection) selectedId = 0; refreshKey++ }

    // Alta de auditoría
    var f_titulo by remember { mutableStateOf("") }
    var f_area by remember { mutableStateOf("") }
    var f_fecha by remember { mutableStateOf("") }
    var f_auditor by remember { mutableStateOf("") }
    Span({ style { color(Color.gray); fontSize(13.px); marginBottom(8.px); display(DisplayStyle.Block) } }) { Text("${lists.size} auditorías registradas") }
    P({ style { margin(0.px, 0.px, 12.px, 0.px); color(Color("#64748b")); fontSize(13.px) } }) {
        Text("Lista de verificación por criterio. Los puntos No conforme generan hallazgos que se convierten en planes de acción trazables.")
    }
    Div({ style { display(DisplayStyle.Flex); gap(8.px); marginBottom(16.px); flexWrap(FlexWrap.Wrap); alignItems(AlignItems.Center) } }) {
        Input(InputType.Text) { placeholder("Título *"); value(f_titulo); onInput { f_titulo = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(200.px) } }
        Input(InputType.Text) { placeholder("Área"); value(f_area); onInput { f_area = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(140.px) } }
        Input(InputType.Text) { placeholder("Fecha *"); value(f_fecha); onInput { f_fecha = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(120.px) } }
        Input(InputType.Text) { placeholder("Auditor"); value(f_auditor); onInput { f_auditor = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(140.px) } }
        Button({ style { padding(8.px, 16.px); backgroundColor(SidebarActiveColor); color(Color.white); property("border", "none"); borderRadius(6.px); cursor("pointer") }; onClick { if (f_titulo.isNotBlank() && f_fecha.isNotBlank()) { scope.launch { client.post("$BACKEND_URL/api/v1/ehs/checklists") { contentType(ContentType.Application.Json); setBody(EhsChecklist(titulo = f_titulo, area = f_area, fecha = f_fecha, auditor = f_auditor)) }; f_titulo = ""; f_area = ""; f_fecha = ""; f_auditor = ""; notice = "Auditoría creada."; refresh() } } else { window.alert("Título y fecha son obligatorios.") } } }) { Text("+ Nueva auditoría") }
    }
    if (notice.isNotBlank()) P({ style { color(Color("#059669")); fontSize(13.px); margin(0.px, 0.px, 10.px, 0.px) } }) { Text(notice) }
    if (error.isNotBlank()) P({ style { color(Color("#dc2626")); fontSize(13.px); margin(0.px, 0.px, 10.px, 0.px) } }) { Text(error) }

    if (isLoading) { P { Text("Cargando...") } } else {
        Table({ style { width(100.percent) } }) {
            Thead { Tr { Th { Text("Título") }; Th { Text("Área") }; Th { Text("Fecha") }; Th { Text("Auditor") }; Th { Text("Estado") }; Th { Text("") } } }
            Tbody {
                lists.forEach { row -> Tr {
                    Td { Text(row.titulo) }; Td { Text(row.area) }; Td { Text(row.fecha) }; Td { Text(row.auditor) }
                    Td { Span({ style { fontWeight(if (row.estado == "Cerrada") "600" else "500"); color(if (row.estado == "Cerrada") Color("#059669") else Color("#d97706")) } }) { Text(row.estado) } }
                    Td { Div({ style { display(DisplayStyle.Flex); gap(4.px) } }) {
                        Button({ style { padding(4.px, 10.px); border(0.px); borderRadius(4.px); cursor("pointer"); backgroundColor(Color("#2563eb")); color(Color.white) }; onClick { selectedId = row.id; refreshKey++ } }) { Text(if (selectedId == row.id) "Viendo" else "Ver") }
                        if (row.estado == "Abierta") Button({ style { padding(4.px, 10.px); border(0.px); borderRadius(4.px); cursor("pointer"); backgroundColor(Color("#059669")); color(Color.white) }; onClick { scope.launch { val resp = client.post("$BACKEND_URL/api/v1/ehs/checklists/${row.id}/cerrar"); if (resp.status.value == 409) { error = "No se puede cerrar: hay puntos sin evaluar."; notice = "" } else { error = ""; notice = "Auditoría cerrada." }; refreshKey++ } } }) { Text("Cerrar") }
                        Button({ style { padding(4.px, 10.px); border(0.px); borderRadius(4.px); cursor("pointer"); backgroundColor(Color("#ef4444")); color(Color.white) }; onClick { scope.launch { val resp = client.delete("$BACKEND_URL/api/v1/ehs/checklists/${row.id}"); if (resp.status.value == 409) { error = "Tiene hallazgos con acciones; no se puede borrar."; notice = "" } else { error = ""; notice = "Auditoría eliminada." }; refresh(false) } } }) { Text("X") }
                    } }
                } }
            }
        }

        // Detalle de la auditoría seleccionada
        if (selectedId > 0) {
            val checklist = lists.firstOrNull { it.id == selectedId }
            Div({ style { marginTop(20.px); padding(14.px); borderRadius(10.px); property("border", "1px solid #e2e8f0"); backgroundColor(Color("#f8fafc")) } }) {
                H4({ style { margin(0.px, 0.px, 4.px, 0.px) } }) { Text("Checklist: ${checklist?.titulo ?: ""}") }
                P({ style { margin(0.px, 0.px, 10.px, 0.px); fontSize(12.px); color(Color("#64748b")) } }) { Text("${items.size} puntos · ${items.count { it.resultado == "NoConforme" }} no conformes · ${items.count { it.resultado == "Conforme" }} conformes") }

                // Agregar punto
                var p_punto by remember { mutableStateOf("") }
                var p_resultado by remember { mutableStateOf("Pendiente") }
                var p_hallazgo by remember { mutableStateOf("") }
                var p_resp by remember { mutableStateOf("") }
                var p_fechaComp by remember { mutableStateOf("") }
                Div({ style { display(DisplayStyle.Flex); gap(8.px); flexWrap(FlexWrap.Wrap); marginBottom(12.px); alignItems(AlignItems.Center) } }) {
                    Input(InputType.Text) { placeholder("Punto de verificación *"); value(p_punto); onInput { p_punto = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(240.px) } }
                    Select({ onChange { p_resultado = it.value ?: "Pendiente" }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1") } }) {
                        listOf("Pendiente", "Conforme", "NoConforme", "NoAplica").forEach { Option(it) { Text(it) } }
                    }
                    Input(InputType.Text) { placeholder("Hallazgo (oblig. si No conforme)"); value(p_hallazgo); onInput { p_hallazgo = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(220.px) } }
                    Input(InputType.Text) { placeholder("Responsable"); value(p_resp); onInput { p_resp = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(140.px) } }
                    Input(InputType.Text) { placeholder("Fecha compromiso"); value(p_fechaComp); onInput { p_fechaComp = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(130.px) } }
                    Button({ style { padding(8.px, 16.px); border(0.px); borderRadius(6.px); cursor("pointer"); backgroundColor(SidebarActiveColor); color(Color.white) }; onClick { if (p_punto.isNotBlank()) { scope.launch { client.post("$BACKEND_URL/api/v1/ehs/checklists/$selectedId/items") { contentType(ContentType.Application.Json); setBody(EhsChecklistItem(checklistId = selectedId, punto = p_punto, resultado = p_resultado, hallazgo = p_hallazgo, responsable = p_resp, fechaCompromiso = p_fechaComp)) }; p_punto = ""; p_hallazgo = ""; p_resp = ""; p_fechaComp = ""; p_resultado = "Pendiente"; refreshKey++ } } else { window.alert("El punto de verificación es obligatorio.") } } }) { Text("+ Punto") }
                }

                Table({ style { width(100.percent); backgroundColor(Color.white); borderRadius(8.px) } }) {
                    Thead { Tr { Th { Text("Punto") }; Th { Text("Resultado") }; Th { Text("Hallazgo") }; Th { Text("Responsable") }; Th { Text("Compromiso") }; Th { Text("Acción") }; Th { Text("") } } }
                    Tbody {
                        items.forEach { item -> Tr {
                            Td { Text(item.punto) }
                            Td { Span({ style { fontWeight("600"); color(when (item.resultado) { "Conforme" -> Color("#059669"); "NoConforme" -> Color("#dc2626"); "NoAplica" -> Color("#64748b"); else -> Color("#d97706") }) } }) { Text(item.resultado) } }
                            Td { Text(item.hallazgo) }
                            Td { Text(item.responsable) }
                            Td { Text(item.fechaCompromiso) }
                            Td { if (item.accionId > 0) Text("Acción #${item.accionId}") else if (item.resultado == "NoConforme") Button({ style { padding(4.px, 10.px); border(0.px); borderRadius(4.px); cursor("pointer"); backgroundColor(Color("#ea580c")); color(Color.white) }; onClick { scope.launch { if (item.responsable.isNotBlank() && item.fechaCompromiso.isNotBlank()) { client.post("$BACKEND_URL/api/v1/ehs/checklists/items/${item.id}/accion") { contentType(ContentType.Application.Json); setBody(item) }; notice = "Plan de acción creado desde el hallazgo."; error = ""; refreshKey++ } else { window.alert("Captura responsable y fecha compromiso en el punto (edítalo con el botón E) para generar la acción.") } } } }) { Text("Crear acción") } else Text("—") }
                            Td { Div({ style { display(DisplayStyle.Flex); gap(4.px) } }) {
                                Button({ style { padding(4.px, 10.px); border(0.px); borderRadius(4.px); cursor("pointer"); backgroundColor(Color("#e2e8f0")) }; onClick { scope.launch { val nuevo = item.copy(resultado = if (item.resultado == "NoConforme") "Conforme" else "NoConforme", hallazgo = if (item.resultado != "NoConforme") (if (item.hallazgo.isBlank()) "Sin conformidad detectada" else item.hallazgo) else item.hallazgo); client.put("$BACKEND_URL/api/v1/ehs/checklists/items/${item.id}") { contentType(ContentType.Application.Json); setBody(nuevo) }; refreshKey++ } } }) { Text("E") }
                                if (item.accionId == 0) Button({ style { padding(4.px, 10.px); border(0.px); borderRadius(4.px); cursor("pointer"); backgroundColor(Color("#ef4444")); color(Color.white) }; onClick { scope.launch { client.delete("$BACKEND_URL/api/v1/ehs/checklists/items/${item.id}"); refreshKey++ } } }) { Text("X") }
                            } }
                        } }
                    }
                }
            }
        }
    }
}

// EHS-12. Evidencia Documental: subir archivos (PDF/imagen) que respaldan
// simulacros, estudios, capacitaciones, dictamenes, etc. Se guardan en el
// servidor y se pueden ver/descargar desde la tabla.
@Composable
fun EhsDocumentsTab(client: HttpClient, scope: kotlinx.coroutines.CoroutineScope) {
    var items by remember { mutableStateOf(emptyList<EhsDocument>()) }
    var isLoading by remember { mutableStateOf(true) }
    var refreshKey by remember { mutableStateOf(0) }
    var statusMsg by remember { mutableStateOf("") }
    var filtroCategoria by remember { mutableStateOf("Todas") }
    var uploading by remember { mutableStateOf(false) }
    var inspections by remember { mutableStateOf(emptyList<SafetyInspection>()) }
    var trainings by remember { mutableStateOf(emptyList<SafetyTraining>()) }
    var drills by remember { mutableStateOf(emptyList<EmergencyDrill>()) }
    var dc3s by remember { mutableStateOf(emptyList<Dc3Constancia>()) }
    var healths by remember { mutableStateOf(emptyList<MedicalExam>()) }

    LaunchedEffect(refreshKey) {
        isLoading = true
        try {
            items = client.get("$BACKEND_URL/api/v1/ehs/documentos").body()
            inspections = client.get("$BACKEND_URL/api/v1/sap/ehs/inspecciones").body()
            trainings = client.get("$BACKEND_URL/api/v1/sap/ehs/capacitaciones").body()
            drills = client.get("$BACKEND_URL/api/v1/sap/ehs/simulacros").body()
            dc3s = client.get("$BACKEND_URL/api/v1/ehs/dc3").body()
            healths = client.get("$BACKEND_URL/api/v1/sap/ehs/salud").body()
        } catch (e: Exception) {
            statusMsg = "No se pudo cargar la evidencia documental: ${e.message ?: "error del servidor"}"
        } finally { isLoading = false }
    }
    fun refresh() { refreshKey++ }

    var f_categoria by remember { mutableStateOf("Inspeccion") }
    var f_titulo by remember { mutableStateOf("") }
    var f_fecha by remember { mutableStateOf("") }
    var f_anio by remember { mutableStateOf("") }
    var f_general by remember { mutableStateOf(false) }
    var f_notas by remember { mutableStateOf("") }
    var selectedFiles by remember { mutableStateOf(emptyList<org.w3c.files.File>()) }
    var completedFiles by remember { mutableStateOf(emptySet<org.w3c.files.File>()) }
    var f_moduleRecordId by remember { mutableStateOf(0) }
    var extraction by remember { mutableStateOf<OperationalDocumentReadResult?>(null) }
    var draftRows by remember { mutableStateOf(emptyList<Map<String, String>>()) }
    var analyzing by remember { mutableStateOf(false) }
    var savingRow by remember { mutableStateOf(false) }
    var analysisFile by remember { mutableStateOf<org.w3c.files.File?>(null) }

    // Los documentos históricos se pueden revisar por ID desde la tabla inferior.
    // Los nuevos se pueden analizar antes de decidir si guardarlos como evidencia.
    Div({ style { marginBottom(16.px); padding(14.px); property("border", "1px solid #cbd5e1"); borderRadius(8.px) } }) {
        H4 { Text("Extraer datos operativos para revisar") }
        P { Text("Elige la sección correcta. La extracción no crea registros ni modifica el documento; revisa cada campo y posibles duplicados antes de guardar.") }
        Select({ onChange { f_categoria = it.value ?: "Inspeccion"; extraction = null; draftRows = emptyList() } }) {
            operationalRoutes.keys.forEach { Option(it) { Text(it) } }
        }
        Input(InputType.File) {
            id("operational-analyze-file")
            attr("accept", ".pdf,.docx,.xls,.xlsx")
            onChange { analysisFile = (document.getElementById("operational-analyze-file") as? HTMLInputElement)?.files?.item(0) }
        }
        Button({ onClick {
            val file = analysisFile
            if (file == null) statusMsg = "Selecciona un archivo para analizar."
            else if (file.size.toLong() > 25L * 1024 * 1024) statusMsg = "El lector admite hasta 25 MiB."
            else if (!analyzing) {
                analyzing = true
                scope.launch {
                    try {
                        val result = analyzeOperationalFile(file, f_categoria)
                        extraction = result; draftRows = result.filas
                        statusMsg = "${result.filas.size} fila(s) sugeridas. ${result.advertencias.joinToString(" ")}"
                    } catch (e: Exception) { statusMsg = "No se pudo analizar: ${e.message}" }
                    finally { analyzing = false }
                }
            }
        } }) { Text(if (analyzing) "Analizando..." else "Analizar archivo") }
        extraction?.let { result ->
            P { Text("Sección: ${result.categoria}. ${result.advertencias.joinToString(" ")}") }
            draftRows.forEachIndexed { index, row ->
                Div({ style { marginBottom(12.px); padding(10.px); property("border", "1px solid #e2e8f0") } }) {
                    P { Text("Fila ${index + 1}: compara con el archivo y con los registros existentes") }
                    result.campos.forEach { field ->
                        Div {
                            Span { Text("$field: ") }
                            Input(InputType.Text) {
                                value(row[field].orEmpty())
                                onInput { event ->
                                    draftRows = draftRows.toMutableList().also { list ->
                                        list[index] = list[index] + (field to event.value)
                                    }
                                }
                            }
                        }
                    }
                    Button({ onClick {
                        if (savingRow) return@onClick
                        val current = draftRows.getOrNull(index) ?: return@onClick
                        val required = requiredOperationalFields[result.categoria].orEmpty()
                        if (required.any { current[it].isNullOrBlank() }) {
                            statusMsg = "Completa los campos obligatorios: ${required.joinToString()}"
                        } else {
                            val route = operationalRoutes[result.categoria] ?: return@onClick
                            savingRow = true
                            scope.launch {
                                try {
                                    client.post("$BACKEND_URL/api/v1/sap/ehs/$route") {
                                        contentType(ContentType.Application.Json)
                                        setBody(JsonObject(current.mapValues { JsonPrimitive(it.value) }))
                                    }
                                    draftRows = draftRows.toMutableList().also { it.removeAt(index) }
                                    statusMsg = "Fila guardada en ${result.categoria}. Vincula la evidencia al registro desde la sección documental si corresponde."
                                    refresh()
                                } catch (e: Exception) { statusMsg = "No se guardó la fila: ${e.message}" }
                                finally { savingRow = false }
                            }
                        }
                    } }) { Text("Guardar esta fila revisada") }
                    Button({ onClick { draftRows = draftRows.toMutableList().also { it.removeAt(index) } } }) { Text("Descartar fila") }
                }
            }
        }
    }

    val categorias = listOf("Inspeccion", "Capacitacion", "Simulacro", "Estudio", "Dictamen", "ExamenMedico", "Incidente", "PermisoTrabajo", "EPP", "Residuos", "Riesgos", "Quimicos", "Auditoria", "DC3", "Normativa", "Otro")
    val moduleType = when (f_categoria) {
        "Inspeccion" -> "inspection"
        "Auditoria" -> "inspection"
        "Simulacro" -> "drill"
        "Capacitacion" -> "training"
        "DC3" -> "dc3"
        "ExamenMedico" -> "health"
        else -> ""
    }
    val linkOptions: List<Pair<Int, String>> = when (moduleType) {
        "inspection" -> inspections.map { it.id to "#${it.id} · ${it.fecha} · ${it.tipoInspeccion} · ${it.area}" }
        "drill" -> drills.map { it.id to "#${it.id} · ${it.fecha} · ${it.tipo}" }
        "training" -> trainings.map { it.id to "#${it.id} · ${it.fecha} · ${it.tema}" }
        "dc3" -> dc3s.map { it.id to "#${it.id} · ${it.trabajador} · ${it.tema} · ${it.fecha}" }
        "health" -> healths.map { it.id to "#${it.id} · ${it.nombreEmpleado.trim()} (${it.empleadoId}) · ${it.fecha}" }
        else -> emptyList()
    }

    Div({ style { backgroundColor(Color.white); padding(20.px); borderRadius(12.px); marginBottom(20.px); property("border", "1px solid #e2e8f0") } }) {
        H4({ style { margin(0.px, 0.px, 12.px, 0.px); color(Color("#0f172a")) } }) { Text("Subir evidencia documental") }
        Div({ style { display(DisplayStyle.Flex); gap(8.px); marginBottom(10.px); flexWrap(FlexWrap.Wrap); alignItems(AlignItems.Center) } }) {
            Select({
                style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(150.px) }
                onChange { f_categoria = it.value ?: "Otro"; f_moduleRecordId = 0 }
            }) {
                categorias.forEach { Option(it) { Text(it) } }
            }
            Input(InputType.Text) { placeholder("Título (opcional si es un archivo)"); value(f_titulo); onInput { f_titulo = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(240.px) } }
            FechaInput(f_fecha, { f_fecha = it }, width = 150)
            if (!f_general) {
                Input(InputType.Text) { placeholder("Año para archivos sin carpeta anual"); value(f_anio); onInput { f_anio = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(240.px) } }
            }
            Select({
                style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1") }
                onChange { f_general = it.value == "general" }
            }) {
                Option("anio") { Text("Sin año: pedir año") }
                Option("general") { Text("Sin año: Categoria/General") }
            }
            Input(InputType.Text) { placeholder("Notas"); value(f_notas); onInput { f_notas = it.value }; style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); width(200.px) } }
            if (moduleType.isNotBlank()) {
                Select({
                    style { padding(8.px); borderRadius(6.px); property("border", "1px solid #cbd5e1"); minWidth(300.px) }
                    onChange { f_moduleRecordId = it.value?.toIntOrNull() ?: 0 }
                }) {
                    Option("0") { Text("Sin vincular / vincular despues (opcional)") }
                    linkOptions.forEach { (id, label) -> Option(id.toString()) { Text(label) } }
                }
            }
        }
        P({ style { fontSize(12.px); color(Color("#475569")) } }) {
            Text("Selecciona varios archivos a la vez. La categoria, fecha, notas y vinculo se aplican a todo el lote; el titulo de cada archivo se toma de su nombre. Vincular con un registro existente es opcional: puedes subir evidencia (p. ej. una inspeccion) aunque el registro todavia no exista en el sistema. Agrupa por categoria o registro cuando sean distintos. Hasta 500 MiB por archivo. Cada archivo recibe un ID y se guarda en Drive/<Categoria>/AÑO (por ejemplo Inspeccion/2026, Simulacro/2026). Para años mezclados usa subcarpetas 2022, 2023, etc. Para archivos que realmente no tienen año, selecciona «Sin año: <Categoria>/General»; los de subcarpetas anuales conservarán su año.")
        }
        fun chooseFiles(id: String) {
            if (uploading) return
            val list = (document.getElementById(id) as? HTMLInputElement)?.files
            selectedFiles = if (list == null) emptyList() else (0 until list.length).mapNotNull { list.item(it) }
            statusMsg = if (selectedFiles.isEmpty()) "Selecciona los archivos para subir." else "${selectedFiles.size} archivos seleccionados."
        }
        Div({ style { display(DisplayStyle.Flex); gap(10.px); alignItems(AlignItems.Center); flexWrap(FlexWrap.Wrap) } }) {
            Span { Text("Archivos:") }
            Input(InputType.File) {
                id("ehs-doc-files")
                attr("multiple", "")
                style { fontSize(13.px) }
                onChange { chooseFiles("ehs-doc-files") }
            }
            Span { Text("Carpeta completa:") }
            Input(InputType.File) {
                id("ehs-doc-folder")
                attr("multiple", "")
                attr("webkitdirectory", "")
                style { fontSize(13.px) }
                onChange { chooseFiles("ehs-doc-folder") }
            }
            Button({
                style { padding(8.px, 16.px); backgroundColor(SidebarActiveColor); color(Color.white); property("border", "none"); borderRadius(6.px); cursor("pointer") }
                onClick {
                    if (uploading) return@onClick
                    val batch = selectedFiles.toList()
                    if (batch.isEmpty()) {
                        statusMsg = "Selecciona archivos o una carpeta primero."
                    } else {
                        // El vinculo con un registro existente (inspeccion, simulacro, capacitacion)
                        // es opcional: se puede cargar evidencia general de la categoria aunque
                        // todavia no exista el registro en el sistema. Si mas tarde se crea el
                        // registro correspondiente, el vinculo se puede añadir editando la evidencia.
                        val fallback = if (f_general) "General" else f_anio.trim()
                        val unresolved = batch.filter { evidenceYear(it, fallback) == null }
                        if (unresolved.isNotEmpty()) {
                            statusMsg = "Falta año para ${unresolved.size} archivos (ej.: ${unresolved.take(3).joinToString { it.name }}). Introduce un año o selecciona carpetas por año."
                        } else if (f_general && f_fecha.isNotBlank() && batch.any { evidenceYear(it, fallback) == -1 }) {
                            statusMsg = "Para archivos General deja la fecha vacía; si conoces su fecha, selecciona el año documental."
                        } else {
                            val category = f_categoria
                            val recordType = moduleType
                            val recordId = f_moduleRecordId
                            val date = f_fecha
                            val notes = f_notas
                            val fallbackYear = fallback
                            val singleTitle = f_titulo.trim()
                            uploading = true
                            scope.launch {
                                var uploaded = 0
                                var skipped = 0
                                val failed = mutableListOf<String>()
                                for ((index, file) in batch.withIndex()) {
                                    val name = file.name
                                    val size = file.size.toLong()
                                    val year = evidenceYear(file, fallbackYear)!!
                                    val folderName = if (year == -1) "General" else year.toString()
                                    statusMsg = "Procesando ${index + 1}/${batch.size}: $name → ${category}/$folderName. Subidos: $uploaded; omitidos: $skipped; errores: ${failed.size}. No cierres esta pestaña."
                                    if (file in completedFiles) {
                                        skipped++
                                        continue
                                    }
                                    if (size <= 0 || size > 500L * 1024 * 1024) {
                                        failed += "$name (vacío o supera 500 MiB)"
                                        continue
                                    }
                                    try {
                                        val title = if (batch.size == 1 && singleTitle.isNotBlank()) singleTitle
                                            else name.substringBeforeLast('.').ifBlank { name }
                                        val id = uploadEvidenceFile(file, mapOf(
                                            "categoria" to category, "titulo" to title, "fecha" to date,
                                            "notas" to notes, "anio" to year.toString(),
                                            "moduleType" to recordType, "moduleRecordId" to recordId.toString()
                                        ))
                                        uploaded++
                                        completedFiles = completedFiles + file
                                        statusMsg = "Subido $name con ID $id en ${category}/$folderName ($uploaded/${batch.size})."
                                    } catch (e: Exception) {
                                        failed += "$name (${e.message ?: "sin confirmación"})"
                                    }
                                }
                                uploading = false
                                refresh()
                                statusMsg = "Lote terminado: $uploaded subidos, $skipped ya subidos en esta sesión, ${failed.size} fallidos de ${batch.size}." +
                                    if (failed.isEmpty()) "" else " Comprueba los fallidos en la lista antes de reintentar: ${failed.joinToString("; ")}"
                            }
                        }
                    }
                }
            }) { Text(if (uploading) "Subiendo lote..." else "Subir archivos seleccionados") }
        }
        if (statusMsg.isNotBlank()) P({ style { marginTop(10.px); fontSize(13.px); color(Color("#2563eb")); marginBottom(0.px) } }) { Text(statusMsg) }
    }

    Div({ style { display(DisplayStyle.Flex); gap(8.px); marginBottom(8.px); alignItems(AlignItems.Center) } }) {
        Span({ style { color(Color.gray); fontSize(13.px) } }) { Text("${items.size} evidencias registradas") }
        Select({ onChange { filtroCategoria = it.value ?: "Todas" } }) {
            Option("Todas") { Text("Todas las categorías") }
            Option("Otro") { Text("Otro: pendiente de revisar") }
            categorias.filter { it != "Otro" }.forEach { Option(it) { Text(it) } }
        }
    }
    if (isLoading) { P { Text("Cargando...") } } else if (items.isEmpty()) {
        P({ style { color(Color.gray); fontSize(13.px) } }) { Text("Aún no hay evidencias. Sube el primer archivo arriba.") }
    } else {
        Div({ style { overflow("auto"); property("border", "1px solid #e2e8f0"); borderRadius(12.px) } }) {
            Table({ style { width(100.percent); property("border-collapse", "collapse"); fontSize(13.px); backgroundColor(Color.white) } }) {
                Thead { Tr { listOf("ID", "Año", "Categoría", "Título", "Fecha doc.", "Archivo", "Subido", "Notas", "").forEach { Th({ style { padding(10.px, 12.px); textAlign("left"); backgroundColor(Color("#f8fafc")); color(Color("#475569")); property("border-bottom", "1px solid #e2e8f0") } }) { Text(it) } } } }
                Tbody {
                    items.filter { filtroCategoria == "Todas" || it.categoria == filtroCategoria }.forEach { doc ->
                        Tr {
                            Td({ style { padding(10.px, 12.px); property("border-bottom", "1px solid #f1f5f9") } }) { Text(doc.id.toString()) }
                            Td({ style { padding(10.px, 12.px); property("border-bottom", "1px solid #f1f5f9") } }) {
                                // Sin año/fecha el registro nunca puede vincularse
                                // automaticamente (el sistema no inventa la fecha de
                                // un documento): se permite completarlo aqui mismo.
                                if (doc.anio <= 0 && doc.fecha.isBlank()) {
                                    Input(InputType.Text, attrs = {
                                        attr("placeholder", "Año")
                                        attr("inputmode", "numeric")
                                        style { width(70.px); fontSize(12.px) }
                                        onChange { event ->
                                            val nuevoAnio = event.value?.toIntOrNull()
                                            if (nuevoAnio != null && nuevoAnio in 2000..2100) scope.launch {
                                                try {
                                                    client.patch("$BACKEND_URL/api/v1/ehs/documentos/${doc.id}/fecha") {
                                                        contentType(ContentType.Application.Json)
                                                        setBody(mapOf("anio" to nuevoAnio.toString()))
                                                    }
                                                    refresh()
                                                } catch (e: Exception) {
                                                    statusMsg = "No se pudo guardar el año de #${doc.id}: ${e.message}"
                                                }
                                            }
                                        }
                                    })
                                } else {
                                    Text(when (doc.anio) { -1 -> "General"; 0 -> "-"; else -> doc.anio.toString() })
                                }
                            }
                            Td({ style { padding(10.px, 12.px); property("border-bottom", "1px solid #f1f5f9") } }) {
                                // Libre: se puede reclasificar cualquier evidencia a cualquier
                                // categoria, no solo las que llegaron como "Otro".
                                Select({
                                    onChange { event ->
                                        val selected = event.value ?: doc.categoria
                                        if (selected != doc.categoria) scope.launch {
                                            try {
                                                client.patch("$BACKEND_URL/api/v1/ehs/documentos/${doc.id}/categoria") {
                                                    contentType(ContentType.Application.Json)
                                                    setBody(mapOf("categoria" to selected))
                                                }
                                                refresh()
                                            } catch (e: Exception) {
                                                statusMsg = "No se pudo reclasificar #${doc.id}: ${e.message}"
                                            }
                                        }
                                    }
                                }) {
                                    val opciones = (listOf(doc.categoria) + categorias.filter { it != doc.categoria }).distinct()
                                    opciones.forEach { opt ->
                                        Option(opt, { if (opt == doc.categoria) selected() }) { Text(if (opt == "Otro") "Otro (revisar)" else opt) }
                                    }
                                }
                            }
                            Td({ style { padding(10.px, 12.px); fontWeight("600"); property("border-bottom", "1px solid #f1f5f9") } }) { Text(doc.titulo) }
                            Td({ style { padding(10.px, 12.px); property("border-bottom", "1px solid #f1f5f9") } }) { Text(doc.fecha.ifBlank { "-" }) }
                            Td({ style { padding(10.px, 12.px); property("border-bottom", "1px solid #f1f5f9") } }) {
                                Button({
                                    style { padding(5.px, 10.px); backgroundColor(Color("#2563eb")); color(Color.white); property("border", "none"); borderRadius(6.px); cursor("pointer"); fontSize(12.px) }
                                    onClick {
                                        // window.open directo no envía Authorization y desde que la
                                        // descarga se protegió con autenticación respondía 401.
                                        // Fetch conserva el control del header, crea un Blob local y
                                        // luego abre el archivo sin exponer el token en la URL.
                                        val url = "$BACKEND_URL/api/v1/ehs/documentos/${doc.id}/descargar"
                                        val options = js("({})")
                                        options.method = "GET"
                                        options.headers = js("({})")
                                        options.headers.Authorization = "Bearer $apiAuthToken"
                                        window.asDynamic().fetch(url, options)
                                            .then { response: dynamic ->
                                                if (!response.ok) throw Exception("HTTP " + response.status)
                                                response.blob()
                                            }
                                            .then { blob: dynamic ->
                                                val blobUrl = window.asDynamic().URL.createObjectURL(blob)
                                                window.open(blobUrl as String, "_blank")
                                                window.setTimeout({ window.asDynamic().URL.revokeObjectURL(blobUrl) }, 60000)
                                            }
                                            .`catch` { err: dynamic ->
                                                statusMsg = "No se pudo abrir ${doc.fileName}: " + (err.message ?: "error de descarga")
                                            }
                                    }
                                }) { Text(if (doc.fileName.isNotBlank()) "📄 ${doc.fileName}" else "Ver") }
                            }
                            Td({ style { padding(10.px, 12.px); property("border-bottom", "1px solid #f1f5f9"); color(Color("#64748b")) } }) { Text(doc.uploadedDate) }
                            Td({ style { padding(10.px, 12.px); property("border-bottom", "1px solid #f1f5f9"); color(Color("#64748b")); fontSize(12.px) } }) { Text(doc.notas.ifBlank { "-" }) }
                            Td({ style { padding(10.px, 12.px); property("border-bottom", "1px solid #f1f5f9") } }) {
                                Button({
                                    style { padding(5.px, 10.px); backgroundColor(Color("#dc2626")); color(Color.white); property("border", "none"); borderRadius(6.px); cursor("pointer"); fontSize(12.px) }
                                    onClick {
                                        scope.launch {
                                            try {
                                                client.delete("$BACKEND_URL/api/v1/ehs/documentos/${doc.id}")
                                                refresh()
                                            } catch (e: Exception) { statusMsg = "No se pudo eliminar: ${e.message}" }
                                        }
                                    }
                                }) { Text("Eliminar") }
                                if (doc.categoria in operationalRoutes) {
                                    Button({ onClick {
                                        if (!analyzing) {
                                            analyzing = true
                                            scope.launch {
                                                try {
                                                    val result: OperationalDocumentReadResult = client.get(
                                                        "$BACKEND_URL/api/v1/ehs/documentos/${doc.id}/extraer").body()
                                                    extraction = result; draftRows = result.filas
                                                    statusMsg = "Evidencia #${doc.id}: ${result.filas.size} fila(s) sugeridas. ${result.advertencias.joinToString(" ")} Revisa la vista previa arriba."
                                                    window.scrollTo(0.0, 0.0)
                                                } catch (e: Exception) { statusMsg = "No se pudo reanalizar #${doc.id}: ${e.message}" }
                                                finally { analyzing = false }
                                            }
                                        }
                                    } }) { Text("Extraer datos") }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
